import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError, change, initialize, reset } from 'redux-form';
import { toFromDates, convertUtcDate, getFromToDates } from '../components/Common/cleanDates';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';

import {
  REQUEST_SALES_ORDERS,
  FETCH_SALES_ORDERS_SUCCESS,
  FETCH_SALES_ORDERS_FAILURE,
  REQUEST_CUSTOMER_PRICES,
  FETCH_CUSTOMER_PRICES_SUCCESS,
  FETCH_CUSTOMER_PRICES_FAILURE,
  SELECT_SALES_ORDER,
  RESET_CURRENT_SALES_ORDER,
  REQUEST_SALES_ORDER_DETAIL,
  FETCH_SALES_ORDER_DETAIL_SUCCESS,
  FETCH_SALES_ORDER_DETAIL_FAILURE,
  REQUEST_CREATING_SALES_ORDER,
  CREATE_SALES_ORDER_SUCCESS,
  CREATE_SALES_ORDER_FAILURE,
  REQUEST_EDITING_SALES_ORDER,
  EDIT_SALES_ORDER_SUCCESS,
  EDIT_SALES_ORDER_FAILURE,
  REQUEST_VOID_SALES_ORDER,
  VOID_SALES_ORDER_SUCCESS,
  VOID_SALES_ORDER_FAILURE,
  REQUEST_CUSTOMER_SALES_HISTORY,
  FETCH_CUSTOMER_SALES_HISTORY_SUCCESS,
  FETCH_CUSTOMER_SALES_HISTORY_FAILURE,
  REQUEST_CUSTOMER_ORDER_SCHEDULES,
  FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS,
  FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE,
  REQUEST_TODAYS_OUTGOING_ORDERS,
  FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS,
  FETCH_TODAYS_OUTGOING_ORDERS_FAILURE,
  REQUEST_SALES_ORDER_LINE_WEIGHTS,
  FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
  FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE,
  REQUEST_SET_ORDER_LINE_WEIGHTS,
  EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
  EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE,
  CLEAR_SALES_ORDER_LINE_WEIGHTS,
  REQUEST_SALES_ORDER_FORM,
  FETCH_SALES_ORDER_FORM_SUCCESS,
  FETCH_SALES_ORDER_FORM_FAILURE,
  CLEAR_INVENTORIES,
  REQUEST_SALES_CSV,
  FETCH_SALES_CSV_SUCCESS,
  FETCH_SALES_CSV_FAILURE,
  REQUEST_SAVE_POS_SALE,
  SAVE_POS_SALE_SUCCESS,
  SAVE_POS_SALE_FAILURE,
  INVALID_CHARACTER_ENTERED,
  CLEAR_ERROR_MESSAGE_IN_POS,
  CHARGE_NOT_MET,
  START_NEW_ORDER,
  REQUEST_DRAFT_DETAILS,
  LOAD_DRAFT_SUCCESS,
  LOAD_DRAFT_FAILURE,
  REQUEST_DRAFTS,
  FETCH_DRAFTS_SUCCESSFUL,
  FETCH_DRAFTS_FAILURE,
  REQUEST_CREATING_SALES_RETURN,
  CREATE_SALES_RETURN_SUCCESS,
  CREATE_SALES_RETURN_FAILURE,
  REQUEST_SALES_RETURN_DETAIL,
  FETCH_SALES_RETURN_DETAIL_SUCCESS,
  FETCH_SALES_RETURN_DETAIL_FAILURE,
  REQUEST_INVENTORY_RETURN,
  FETCH_INVENTORY_RETURN_SUCCESS,
  FETCH_INVENTORY_RETURN_FAILURE,
  REQUEST_INVENTORY_RETURN_DETAILS,
  FETCH_INVENTORY_RETURN_DETAILS_SUCCESS,
  FETCH_INVENTORY_RETURN_DETAILS_FAILURE,
  EDIT_INVENTORY_RETURN,
  EDIT_INVENTORY_RETURN_SUCCESS,
  EDIT_INVENTORY_RETURN_FAILURE,
  REQUEST_CURRENCY_RATES,
  FETCH_CURRENCY_RATES_SUCCESS,
  FETCH_CURRENCY_RATES_FAILURE,
  EDIT_MULTI_CURRENCIES,
  EDIT_MULTI_CURRENCIES_SUCCESS,
  EDIT_MULTI_CURRENCIES_FAILURE,
  REQUEST_TAX_RATES,
  FETCH_TAX_RATES_SUCCESS,
  FETCH_TAX_RATES_FAILURE,
  REQUEST_CREATE_TAX_RATE,
  CREATE_TAX_RATE_SUCCESS,
  CREATE_TAX_RATE_FAILURE,
  EDIT_MULTI_TAXES,
  EDIT_MULTI_TAXES_SUCCESS,
  EDIT_MULTI_TAXES_FAILURE,
  DELETE_TAX,
  DELETE_TAX_SUCCESS,
  DELETE_TAX_FAILURE,
  REQUEST_OVERALL_SALES_PERFORMANCE,
  FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS,
  FETCH_OVERALL_SALES_PERFORMANCE_FAILURE,
  REQUEST_POS_REPORT,
  FETCH_POS_REPORT_SUCCESS,
  FETCH_POS_REPORT_FAILURE,
  REQUEST_SALES_INVENTORY_INFO,
  FETCH_SALES_INVENTORY_INFO_SUCCESS,
  FETCH_SALES_INVENTORY_INFO_FAILURE,
  REQUEST_SALES_CUSTOMER_DETAIL,
  FETCH_SALES_CUSTOMER_DETAIL_SUCCESS,
  FETCH_SALES_CUSTOMER_DETAIL_FAILURE,
  REQUEST_SHIPPING_DETAIL,
  FETCH_SHIPPING_DETAIL_SUCCESS,
  FETCH_SHIPPING_DETAIL_FAILURE,
  REQUEST_PURCHASES_VENDOR_DETAIL,
  FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS,
  FETCH_PURCHASES_VENDOR_DETAIL_FAILURE,
  REQUEST_ITEM_SALES_HISTORY,
  REQUEST_ITEM_PURCHASE_HISTORY,
  FETCH_ITEM_SALES_HISTORY_SUCCESS,
  FETCH_ITEM_PURCHASE_HISTORY_SUCCESS,
  FETCH_ITEM_SALES_HISTORY_FAILURE,
  FETCH_ITEM_PURCHASE_HISTORY_FAILURE,
  REQUEST_CUSTOMER_FREQUENT,
  FETCH_CUSTOMER_FREQUENT_SUCCESS,
  FETCH_CUSTOMER_FREQUENT_FAILURE,
  CLEAR_SALES_CUSTOMER_DETAILS,
  SET_SALES_ORDERS_FILTER,
  REQUEST_SALES_PERFORMANCE,
  REQUEST_SALES_PERFORMANCE_SUCCESS,
  REQUEST_SALES_PERFORMANCE_FAILURE,
  REQUEST_SALES_DASHBOARD_DETAIL,
  FETCH_SALES_DASHBOARD_DETAIL_SUCCESS,
  FETCH_SALES_DASHBOARD_DETAIL_FAILURE,
  REQUEST_SALES_LEVELS,
  FETCH_SALES_LEVELS_SUCCESS,
  FETCH_SALES_LEVELS_FAILURE,
  REQUEST_REFUND,
  REQUEST_REFUND_SUCCESS,
  REQUEST_REFUND_FAILURE,
  REQUEST_RETURN_VOID,
  REQUEST_RETURN_COMPLETE,
  FETCH_RETURN_SUCCESS,
  FETCH_RETURN_FAILURE,
  REQUEST_SHIPPING_LIST_PDF,
  FETCH_SHIPPING_LIST_SUCCESS,
  REQUEST_PACKING_LIST_PDF,
  FETCH_PACKING_LIST_SUCCESS,
  REQUEST_SO_PDF,
  FETCH_SO_PDF_SUCCESS,
  REQUEST_SO_SI_PDF,
  FETCH_SO_SI_PDF_SUCCESS,
  REQUEST_BOL_ID_PDF,
  FETCH_BOL_ID_PDF_SUCCESS,
  REQUEST_BOL_WITHOUT_LOG,
  FETCH_BOL_WITHOUT_LOG_SUCCESS,
  REQUEST_BOL_LABEL,
  FETCH_BOL_LABEL_SUCCESS,
  REQUEST_BOL_FBA_PDF,
  FETCH_BOL_FBA_PDF_SUCCESS,
  FETCH_BOL_ADDRESS_SUCCESS,

  FETCH_SP_SUCCESS,
  REQUEST_SP_PDF,

  REQUEST_REFUND_PDF,
  REQUEST_REFUND_PDF_SUCCESS,
  REQUEST_PICKING_LIST_PDF,
  FETCH_PICKING_LIST_SUCCESS,
  REQUEST_PRODUCT_BY_ID,
  FETCH_PRODUCT_BY_ID_SUCCESS,
  FETCH_PRODUCT_BY_ID_FAILURE,
  KEEP_EST_DATE,
  FINISHED_UNMOUNT,
  DESTROY_EST_DATE,
  FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS,
  REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL,
  REQUEST_SALES_TOTALS,
  FETCH_SALES_TOTALS_SUCCESS,
  FETCH_SALES_TOTALS_FAILURE,
  REQUEST_SALES_ORDER_DETAIL_BY_NUM,
  FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS,
  FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE,
  REQUEST_SALES_ORDER_TO_QUOTE,
  SALES_ORDER_TO_QUOTE_SUCCESS,
  SALES_ORDER_TO_QUOTE_FAILURE,
  REQUEST_SALES_QUOTE_TO_OPEN,
  REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS,
  REQUEST_SALES_QUOTE_TO_ORDER_FAILURE,
  CREATE_MOBILE_TASK,
  CREATE_MOBILE_TASK_SUCCESS,
  CREATE_MOBILE_TASK_FAILURE,
  REQUEST_SET_SHIPPING_WEIGHT,
  UPDATE_SHIPPING_WEIGHT_SUCCESS,
  UPDATE_SHIPPING_WEIGHT_FAILURE,
  REQUEST_SET_SHIPPING_WEIGHT_SPLIT,
  UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO,
  SALES_ORDER_FORM_BATCHES,
  SALES_RETURN_PDF,
  REQUEST_PRODUCT_BATCHES,
  FETCH_PRODUCT_INFO_SUCCESS,
  SET_SALES_ORDERS_PAGINATION_FILTER,
  REQUEST_CREATING_SALES_QUOTE,
  FETCH_CURRENT_ORDER_REQUESTS,
  ADD_PRODUCT_REQUESTS,
  REMOVE_PRODUCT_REQUESTS,
  ADD_PRODUCT_IMAGES,
  REMOVE_PRODUCT_IMAGES,
  ADD_PRODUCT_FILES,
  REMOVE_PRODUCT_FILES,
  CREATE_PICKING_LIST,
  CREATE_PICKING_LIST_REQUEST,
  REQUEST_SYNC_QB_PDF,
  FETCH_SYNC_QB_PDF_SUCCESS,
  FETCH_SYNC_QB_PDF_FAILURE,
} from './type';

import {
  FETCH_FJ_AGENTS_URL,
  SEND_EMAIL,
  SALES_SAVE_TO_INVOICE,
  FETCH_FJ_CARRIERS_URL,
  FETCH_FBA_ADDRESS_URL,
  INVENTORIES_URL,
  SALES_ORDERS_URL,
  SALES_QUOTE_URL,
  SALES_ORDERS_REFUND,
  MOBILE_SALES_ORDERS_URL,
  SALES_DASHBOARD_URL,
  OUTGOING_ORDERS_BY_DATE_URL,
  SALES_ORDER_LINE_WEIGHTS_URL,
  FETCH_SALES_ORDER_FORM_URL,
  POS_SALE_URL,
  DASHBOARD_URL,
  SALES_RETURN_URL,
  SALES_ISSUE_CREDIT_URL,
  TAX_RATES_URL,
  CURRENCY_RATES_URL,
  OVERALL_SALES_PERFORMANCE_URL,
  POS_REPORT_URL,
  SALES_INVENTORY_INFO_URL,
  SALES_CUSTOMER_URL,
  PURCHASES_VENDOR_URL,
  ITEM_HISTORY_URL,
  ITEM_PURCHASE_HISTORY_URL,
  FREQUENT_ITEMS_URL,
  INBOUND_PRODUCTS_URL,
  SALES_PERFORMANCE_URL,
  SALES_LOADSPOST_URL,
  SALES_LEVELS_URL,
  SHIPPING_URL,
  SALES_ORDER_PRODUCT_BY_ID_URL,
  SHIPPING_LIST_URL,
  PICKING_LIST_URL,
  PACKING_LIST_URL,
  REFUND_SUMMARY_URL,
  SALES_ORDER_PRINT_URL,
  QUOTE_TO_ORDER_URL,
  SALES_ORDER_LABEL_PRINT_URL,
  WIZ_PRINT_BOL,
  SALES_ORDER_LABEL_PRINT_URL_BATCH,
  CUSTOMER_SALES_HISTORY,
  PATCH_SALES_ORDER_WEIGHT_URL,
  PATCH_SALES_ORDER_WEIGHT_MULTI_URL,
  PATCH_SALES_EMPLOYEE_NOTE_URL,
  PATCH_SALES_VOID_NOTE_URL,
  FETCH_SALES_ORDER_WEIGHT_TRACKING,
  FETCH_JML_TRACKING_NUMBER_URL,
  PRINT_JML_LABEL_URL,
  SALES_ORDER_RESHIP_URL,
  CHOWBUS_IMPORT,
  PAYMENT_URL,
  OVERSEA_URL,
  OVERSEA_UPLOAD_BOL_IMAGE_URL,
  OVERSEA_DELETE_BOL_IMAGE_URL,
  OVERSEA_PRINT_BOL_URL,
  SP_PDF_URL,
  OVERSEA_PRINT_BOL_WITHOUT_LOG_URL,
  OVERSEA_PRINT_BOL_LABEL_URL,
  OVERSEA_ADDRESS_URL,
  CARRIER_INFO_URL,
  SET_QUOTE_URL,
  SO_TO_PO_DAVIS_URL,
  USPRIDE_IMPORT,
  USPRIDE_PRINT_SO_USPRIDE,
  SYNC_TO_MES,
  USPRIDE_REPRINT_SO_USPRIDE,
  SO_PRINT_SALES_INVOICE_URL,
  COMPANY_URL,
  WAREHOUSE_BY_COMPANY_URL,
  SALES_ORDER_FORM_BACHES,
  PROMOTIONS_URL,
  SET_QUOTE_ESC_URL,
  SALES_QUOTE_LAP_PRINT_URL,
  SALES_QUOTE_CUSTOMER_URL,
  ABCFF_IMPORT, MFG_SALES_ORDER_REVIEW_URL,
  MFG_SALES_ORDER_REQ_APPROVAL_URL,
  MFG_SALES_ORDER_PENDING_APPROVAL_URL, CREATE_PR_URL, PATCH_SALES_ORDER_WEIGHT_MULTI_VAK_URL,
  CREATE_PICKING_LIST_URL,
  DASHBOARD_SO_PAST_URL,
  ROOT_URL_V2,
} from './url';

import {
  ROOT_URL, ROOT_API_URL, isGGI, isABBLE, isHMM, isSKH, isLAP, isOLG,
  isABCFF, isVAK, isKM, isEKC, isSV, isLMH, isBRO, isSDR, isCRW, isSH, isCCW, isSC
} from './root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isDst } from '../components/Common/NumberUtil';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';

const isABC = ROOT_URL === 'https://abc-scm.truckxi.com/api/' || ROOT_API_URL === 'https://abc-scm.truckxi.com/api/';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";

export function updateMSOFormInitialValues (data) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO,
      payload: data,
    });
  };
};

export const handlePutInSubmit = (data, success, failed) => {
  axios({
    method: 'put',
    data,
    url: `${ROOT_URL_V2}inventory/relocation_v2_mulit_warehouse_lap/`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    console.log('put in success', res)
    success()
  }).catch(errRes => {
    failed()
    console.log('put in failed', errRes)
  })
}

export function fetchSalesOrders() {
  return (dispatch) => {
    dispatch(requestSalesOrders());
    return axios.get(
      SALES_ORDERS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrdersSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrdersFailure(err));
      });
  };
}

export function requestSalesOrders() {
  return {
    type: REQUEST_SALES_ORDERS,
  };
}

export function fetchSalesOrdersSuccess(salesOrders) {
  return {
    type: FETCH_SALES_ORDERS_SUCCESS,
    payload: salesOrders,
  };
}

export function fetchSalesOrdersFailure(error) {
  return {
    type: FETCH_SALES_ORDERS_FAILURE,
    payload: error,
  };
}

export const generateSOWithExcelUSPride = (file, platform, customer, cb) => {
  let url = `${isABCFF ? ABCFF_IMPORT : USPRIDE_IMPORT}?platform=${platform}`;
  if (isABCFF) {
    url = `${ABCFF_IMPORT}?platform=${platform}&customer_id=${customer}`;
  }

  axios({
    method: 'post',
    url,
    data: file,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    cb && cb();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}

export const expressMultipleSOInvoices = (pks, success) => {
  const url = isVAK ? `${ROOT_URL}v1/sale/multi_express_invoice/${pks.join(',')}` : `${ROOT_URL}v2/sales/multi_express_invoice/${pks.join(',')}`;
  axios({
    method: 'POST',
    url,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    alert(res.data);
    success && success(true);
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    if(isVAK) {
      success && success(false);
    }
    alert(JSON.stringify(err.data));
  });
}

export const printSalesOrderLabelUSPride = (data, cb) => dispatch => {
  dispatch({ type: REQUEST_SO_PDF });
  axios({
    method: 'post',
    url: `${USPRIDE_PRINT_SO_USPRIDE}`,
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    responseType: 'blob',
  }).then(res => {
    dispatch(fetchSalesOrderPDFSuccess(res));
    cb && cb();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    // alert(err.data);
    alert('Error: Cannot generate new tracking numbers. Please check Shipstation settings.');
    dispatch(fetchSalesOrderPDFSuccess([]));
  })
}
export const handleSyncToMES = (id, success, failed) => dispatch => {
  axios({
    method: 'POST',
    url: `${SYNC_TO_MES}${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    if (res.data && res.data.code === 200) {
      success();
    } else {
      alert(res.data ? res.data.msg : '')
      failed();
    }
  }, (err) => {
    failed();
    let errMSG = '';
    if (err.data && err.data.msg) {
      errMSG = err.data.msg
    }
    alert(JSON.stringify(errMSG));
  })
}

export const reprintSalesOrderLabelUSPride = (data, cb) => dispatch => {
  axios({
    method: 'post',
    url: `${USPRIDE_REPRINT_SO_USPRIDE}`,
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    responseType: 'blob',
  }).then(res => {
    dispatch(fetchSalesOrderPDFSuccess(res));
    cb && cb();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}

export const setSOToPending = (id, cb) => dispatch => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/sales_order/set_sales_order_status_to_pending/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    cb && cb();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}

export const setSOToQuote = (id, cb) => dispatch => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/sales_order/set_sales_order_status_to_quote/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    cb && cb();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}

export function fetchSalesOdersByDate(postingDateGT, postingDateLT, days) {
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  return (dispatch) => {
    dispatch(requestSalesOrders());
    return axios.get(
      `${SALES_ORDERS_URL}search/?OrderDate__gte=${dates.fromDate
      }&OrderDate__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrdersSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrdersFailure(err));
      });
  };
}

export function selectSalesOrder(salesOrder) {
  return {
    type: SELECT_SALES_ORDER,
    payload: salesOrder,
  };
}


export function resetCurrentSalesOrder() {
  return {
    type: RESET_CURRENT_SALES_ORDER,
  };
}

export const fetchMultiSOLines = (ids, success) => dispatch  => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/sale/merge_sales_invoice/${ids}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success(res.data);
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}

export const duplicateSOAPI = (pk, success, failed) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/sale/duplicate/${pk}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    failed();
    let errMSG = '';
    if (err.data) {
      errMSG = err.data
    } else {
      errMSG = err
    }
    alert(JSON.stringify(errMSG));
  })
}

export const resetLocation = (id) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v2/set_location/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    alert('Reset Location!');
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}

export function keepEstDate(date, route) {
  return (dispatch) => {
    dispatch(keepEstDateSuccess(date));
    browserHistory.push(route);
  };
}

export function keepEstDateSuccess(date) {
  return {
    type: KEEP_EST_DATE,
    payload: date,
  };
}

export function destroyEstDate() {
  return {
    type: DESTROY_EST_DATE,
  };
}

export function finishUnmount() {
  return {
    type: FINISHED_UNMOUNT,
  };
}

// Fetch the detail page.
export function fetchSalesOrderDetail(salesOrder_id, route, status = '', success='', from = '') {
  const apiUrl = (route === 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  let url = `${apiUrl}?pk=${salesOrder_id}`;
  if(status === 'Backlog') {
    url += '&backlog=true';
  }
  if(status === 'Backorder') {
    url += '&backorder=true';
  }
  return (dispatch) => {
    dispatch(requestSalesOrderDetail());
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailSuccess(response, success, from));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailFailure(err));
      });
  };
}

export function requestSalesOrderDetail() {
  return {
    type: REQUEST_SALES_ORDER_DETAIL,
  };
}

export function fetchSalesOrderDetailSuccess(salesOrderDetail, success = '', from = '') {
  salesOrderDetail = { ...salesOrderDetail.data };
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = convertUtcDate(salesOrderDetail.OrderDate);
  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = convertUtcDate(salesOrderDetail.ETADate);
  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = convertUtcDate(salesOrderDetail.ReceivedDate);
  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = convertUtcDate(salesOrderDetail.DispatchDate);

  if (!isLAP) {
    if (salesOrderDetail.ShippingMethod) {
      const array = salesOrderDetail.ShippingMethod.split('/');
      if (array.length===1) {
        salesOrderDetail.shipMethod = salesOrderDetail.ShippingMethod.split('/')[0];
        if(isOLG) {
          if(salesOrderDetail.ShippingMethod == 'Pick up') salesOrderDetail.ShippingMethod = 'Pick up 提货';
          if(salesOrderDetail.ShippingMethod == 'Delivery') salesOrderDetail.ShippingMethod = 'Delivery 运送';
        }
      } else {
        salesOrderDetail.shipCarrier = salesOrderDetail.ShippingMethod.split('/')[0];
        salesOrderDetail.shipMethod = salesOrderDetail.ShippingMethod.split('/')[1];
      }
    }
  }

  salesOrderDetail.Sales_Order_Lines = salesOrderDetail.Sales_Order_Lines.map(line => {
    return {
      ...line,
      originQty: line.Quantity,
    }
  })
  if(success && isOLG) {
    success(salesOrderDetail);
  }
  return {
    type: FETCH_SALES_ORDER_DETAIL_SUCCESS,
    payload: {salesOrderDetail, from},
  };
}

export function fetchSalesOrderDetailFailure(error) {
  return {
    type: FETCH_SALES_ORDER_DETAIL_FAILURE,
    payload: error,
  };
}

export function requestSalesOrderDetailByNum() {
  return {
    type: REQUEST_SALES_ORDER_DETAIL_BY_NUM,
  };
}

export function fetchSalesOrderDetailByNumSuccess(salesOrderDetail) {
  return {
    type: FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS,
    payload: salesOrderDetail.data,
  };
}

export function fetchSalesOrderDetailByNumFailure(error) {
  return {
    type: FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE,
    payload: error,
  };
}


export function fetchSalesOrderDetailByNum(SONum) {
  return (dispatch) => {
    dispatch(requestSalesOrderDetailByNum());
    return axios.get(
      `${SALES_ORDERS_URL}?SONum=${SONum}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailByNumSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailByNumFailure(err));
      });
  };
}
export function createSalesQuote({
  Delivery,
  HandlingFee,
  PercentageFee,
  TransFee,
  Surcharge,
  Sales_Order_Lines,
  Deliver_CustomerDetail_id,
  Deliver_Customer_id,
  IsWholesale,
  PaymentTerm_id,
  Agent_id,
  Pickup_Warehouse_id,
  OrderDate,
  ETADate,
  DispatchDate,
  // dsq
  OrderType,
  ContainerNum,
  IsFBAAddress,
  DestinationAddress,
  ISANum,
  Trucker,
  ReleaseDate,
  ReadyDate,
  OutboundDate,
  ShipmentID,
  OriginalPrice,
  Destination,
  ContainerSize,
  ISANote,
  DLNum,
  Carrier,
  Port,
  LFDate,
  IsDO,
  IsDirectShip,
  IsBOL,
  IsSeal,
  BOL,
  POD,
  IsPOD,
  FBARoute,
  ReceiveType,
  ReceiveUnit,
  DropshipType,
  Appointment,
  AppointmentDate,
  TruckingCo,
  DeliverTo,
  IsReturnEmpty,
  ArrivalDate,
  ReturnDate,
  StorageInDate,
  StorageOutDate,
  // dsq
  ExtInvoiceNum,
  Broker,
  Truckload,
  TruckNum,
  Dispatch,
  DetentionRate,
  LumperFee,
  PalletSpace,
  PickupDriver,
  PickupTrailerNum,
  PickupDate,
  PickupTime,
  PickupStreet,
  PickupZip,
  PickupCity,
  PickupState,
  PickupAppt,
  DropoffDriver,
  DropoffTrailerNum,
  DropoffDate,
  DropoffTime,
  DropoffStreet,
  DropoffZip,
  DropoffCity,
  DropoffState,
  DropoffAppt,
  // fj
  IsOutbound,
  RefNum,
  Type,
  ClientCustName,
  ShipByDate,
  ShipDate,
  CancelDate,
  SalesOrderType,
  TypeRefNum,
  ShipNote,
  Commission,
  Commission2,
  DocumentDate,
  UpdateTime,
  FinalNetWeight,
  FinalShippingWeight,
  TotalPrice,
  FinalWeight,
  CarryType,
  Discount,
  Savings,
  ShippingCost,
  HandlingCost,
  SalesStatus,
  MiscCost,
  MiscNote,
  TaxAmount,
  TaxRate,
  FinalPrice,
  ConvertItemPrice,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Sales_User_id,
  Sales_User_id2,
  Picker_User_id,
  Packer_User_id,
  Creator_User_id,
  Product_id,
  Modifier_User_id,
  Notation,
  EmployeeNote,
  RouteNote,
  Note,
  TotalCRV,
  RefPrice,
  IsNoReduce,
  TrailerNum,
  Trailer,
  DSQID,
  CPO,
  LoadId,
  Type_wmb2b,
  Dept_wmb2b,
  //mag
  SaleStatus,
  delivery_address,
  delivery_eta,
  delivery_lfd,
  DeliveryStatus,
  cntrLocation,
  mag_note_other,
  DeliveryStatusOther,
  contact_person,
  contact_email,
  cntrNum,
  bolNum,
  shipping_line,
  size,
  cargo_weight,
  terminal,
  mag_note,
  OrderPalletQty,
  // cnt
  ShippingMethod,
  // fung, fv
  PONum,
  //TQ
  Company_id,
  IsRelocation,
  PickAddress,
  ShipVia,
  IsLowerThanLowestPrice,
  IsOverCreditLimit,
  Truck_CustomerDetail_id,
  // skh
  Channel,
}, additionalParams, extra) {
  if (Truck_CustomerDetail_id && Truck_CustomerDetail_id) {
    Truck_CustomerDetail_id = Truck_CustomerDetail_id.value
  }
  if (isSV && !ShipDate) {
    ShipDate = new Date();
  }
  if (SalesOrderType && SalesOrderType.value) {
    SalesOrderType = SalesOrderType.value;
  }
  if (ShipVia && ShipVia.value) {
    ShipVia = ShipVia.value;
  }
  if (Company_id && Company_id.value) {
    Company_id = Company_id.value;
  }
  if (PaymentTerm_id && PaymentTerm_id.value) {
    PaymentTerm_id = PaymentTerm_id.value;
  }
  if (Agent_id && Agent_id.value) {
    Agent_id = Agent_id.value;
  }
  if (isFJ && Carrier && Carrier.value) {
    Carrier = Carrier.value;
  }
  if (DestinationAddress && DestinationAddress.value) {
    DestinationAddress = DestinationAddress.value;
  }
  if (PickupState && PickupState.value) {
    PickupState = PickupState.value;
  }
  if (DropoffState && DropoffState.value) {
    DropoffState = DropoffState.value;
  }
  if (ContainerSize && ContainerSize.value) {
    ContainerSize = ContainerSize.value;
  }
  if (ReceiveType && ReceiveType.value) {
    ReceiveType = ReceiveType.value;
  }
  if (ReceiveUnit && ReceiveUnit.value) {
    ReceiveUnit = ReceiveUnit.value;
  }
  if (isJTB && OrderType && OrderType.value) {
    OrderType = OrderType.value;
  }
  if (isMAG && SaleStatus && SaleStatus.value) {
    SaleStatus = SaleStatus.value;
  }
  if (isMAG && shipping_line && shipping_line.value) {
    shipping_line = shipping_line.value;
  }
  if (isMAG && terminal && terminal.value) {
    terminal = terminal.value;
  }
  if (isMAG && mag_note && mag_note.value) {
    mag_note = mag_note.value;
  }
  if (isMAG && size && size.value) {
    size = size.value;
  }
  if (DropshipType && DropshipType.value) {
    DropshipType = DropshipType.value;
  }
  if (!UpdateTime) UpdateTime = convertUtcDate();
  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
  if(isHMM) {
    Sales_Order_Lines = Sales_Order_Lines.map( line => {
      return {
        ...line,
        TotalPrice: line.Quantity * line.UnitPrice * line.PackageSize_1
      }
    })
  }

  let dsqWT = false;
  if (isDSQ || isABCFF) {
    Sales_Order_Lines.map( (line,i) => {
      if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
        alert("Please enter either Box or Pallet quantity for each line.");
        dsqWT = true;
      }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (line.Quantity && (Number(line.Quantity) > 0)) {
          alert("A single product line cannot contain both Box and Pallet quantities.");
          dsqWT = true;
        }
      }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
          Sales_Order_Lines[i].Quantity = "1";
        }
      }
    });
    if (dsqWT) {
      return;
    }
  }

  if (isMAG) {
    Sales_Order_Lines = [
      {
        "ProductTax": 0,
        "CRV": 0,
        "Product_id": 1,
        "SalesOrderLine_id": 27,
        "ImageUrl": null,
        "RefPrice": 600,
        "RefNum": "",
        "TotalNetWeight": 1,
        "ProductType": "Fixed",
        "TotalShippingWeight": 0,
        "MeasureUnit": "LB",
        "TotalPrice": 600,
        "NetWeight": 1,
        "Description": "服务费",
        "PackageSize": "1case*1case",
        "PackageSize_1": "1",
        "IsTaxable": false,
        "Remark": null,
        "ProductDescription": "服务费",
        "Name": "service fee",
        "ProductNum": "01010001",
        "PackageType": "case",
        "Product_id_id": 1,
        "PickupQuantity": 0,
        "CostPrice": 0,
        "IsMobileLine": null,
        "Order": 1,
        "Quantity": 1,
        "IsForFree": false,
        "ProductName": "service fee",
        "SalesOrder_id_id": 27,
        "LoadedQuantity": 0,
        "Weights": null,
        "Batch_PONum": null,
        "UnitPrice": 600
      }
    ];
  }

  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_ORDER });
    axios.post(
      (extra === 'invoice') ? `${SALES_SAVE_TO_INVOICE}` : `${SALES_QUOTE_URL}`,
      {
        Truck_CustomerDetail_id,
        Delivery,
        HandlingFee,
        PercentageFee,
        TransFee,
        Surcharge,
        IsLowerThanLowestPrice,
        IsOverCreditLimit,
        PickAddress,
        ShipVia,
        IsRelocation,
        Sales_Order_Lines,
        Deliver_CustomerDetail_id,
        Deliver_Customer_id,
        IsWholesale,
        PaymentTerm_id,
        Agent_id,
        Pickup_Warehouse_id,
        OrderDate,
        ETADate,
        DispatchDate,
        PONum,
        // dsq
        OrderType,
        ContainerNum,
        IsFBAAddress,
        DestinationAddress,
        ISANum,
        Trucker,
        ReleaseDate,
        ReadyDate,
        OutboundDate,
        ShipmentID,
        OriginalPrice,
        Destination,
        ContainerSize,
        ISANote,
        DLNum,
        Carrier,
        Port,
        LFDate,
        IsDO,
        IsDirectShip,
        IsBOL,
        IsSeal,
        BOL,
        POD,
        IsPOD,
        FBARoute,
        ReceiveType,
        ReceiveUnit,
        DropshipType,
        Appointment,
        AppointmentDate,
        TruckingCo,
        DeliverTo,
        IsReturnEmpty,
        ArrivalDate,
        ReturnDate,
        StorageInDate,
        StorageOutDate,
        // dsq
        ExtInvoiceNum,
        Broker,
        Truckload,
        TruckNum,
        Dispatch,
        DetentionRate,
        LumperFee,
        PalletSpace,
        PickupDriver,
        PickupTrailerNum,
        PickupDate,
        PickupTime,
        PickupStreet,
        PickupZip,
        PickupCity,
        PickupState,
        PickupAppt,
        DropoffDriver,
        DropoffTrailerNum,
        DropoffDate,
        DropoffTime,
        DropoffStreet,
        DropoffZip,
        DropoffCity,
        DropoffState,
        DropoffAppt,
        //
        IsOutbound,
        RefNum,
        Type,
        ClientCustName,
        ShipByDate,
        ShipDate,
        CancelDate,
        ShipNote,
        SalesOrderType,
        TypeRefNum,
        Commission,
        Commission2,
        DocumentDate,
        UpdateTime,
        FinalNetWeight,
        FinalShippingWeight,
        TotalPrice,
        FinalWeight,
        CarryType,
        Discount,
        Savings,
        ShippingCost,
        HandlingCost,
        MiscCost,
        MiscNote,
        TaxAmount,
        TaxRate,
        SalesStatus,
        FinalPrice,
        ConvertItemPrice,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Sales_User_id,
        Sales_User_id2,
        Picker_User_id,
        Packer_User_id,
        Creator_User_id,
        Product_id,
        Modifier_User_id,
        Notation,
        EmployeeNote,
        RouteNote,
        Note,
        TotalCRV,
        RefPrice,
        IsNoReduce,
        TrailerNum,
        Trailer,
        DSQID,
        CPO,
        LoadId,
        Type_wmb2b,
        Dept_wmb2b,
        cntrNum,
        //mag
        SaleStatus,
        delivery_address,
        delivery_eta,
        delivery_lfd,
        DeliveryStatus,
        cntrLocation,
        mag_note_other,
        DeliveryStatusOther,
        contact_person,
        contact_email,
        bolNum,
        shipping_line,
        size,
        cargo_weight,
        terminal,
        mag_note,
        OrderPalletQty,
        // cnt
        ShippingMethod,
        // fung, fv
        //TQ
        Company_id,
        ...additionalParams,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        // if (isSDR && response && response.data) {
        //   sendEmail(response.data.SalesOrder_id);
        // }
        dispatch(createSalesOrderSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createSalesOrderFailure(err));
      });
  };
}

export function createSalesOrder({
  Delivery,
  HandlingFee,
  PercentageFee,
  TransFee,
  Surcharge,
  IsRelocation,
  Sales_Order_Lines,
  Deliver_CustomerDetail_id,
  Deliver_Customer_id,
  IsWholesale,
  PaymentTerm_id,
  Agent_id,
  Pickup_Warehouse_id,
  OrderDate,
  ETADate,
  DispatchDate,
  DispatchStartTime,
  DispatchEndTime,
  PONum,
  // dsq
  OrderType,
  ContainerNum,
  IsFBAAddress,
  DestinationAddress,
  ISANum,
  Trucker,
  ReleaseDate,
  ReadyDate,
  OutboundDate,
  ShipmentID,
  OriginalPrice,
  Destination,
  ContainerSize,
  ISANote,
  DLNum,
  Carrier,
  Port,
  LFDate,
  IsDO,
  IsDirectShip,
  IsBOL,
  IsSeal,
  BOL,
  POD,
  IsPOD,
  FBARoute,
  ReceiveType,
  ReceiveUnit,
  DropshipType,
  Appointment,
  AppointmentDate,
  TruckingCo,
  DeliverTo,
  IsReturnEmpty,
  ArrivalDate,
  ReturnDate,
  StorageInDate,
  StorageOutDate,
  // dsq
  ExtInvoiceNum,
  Broker,
  Truckload,
  TruckNum,
  Dispatch,
  DetentionRate,
  LumperFee,
  PalletSpace,
  PickupDriver,
  PickupTrailerNum,
  PickupDate,
  PickupTime,
  PickupStreet,
  PickupZip,
  PickupCity,
  PickupState,
  PickupAppt,
  DropoffDriver,
  DropoffTrailerNum,
  DropoffDate,
  DropoffTime,
  DropoffStreet,
  DropoffZip,
  DropoffCity,
  DropoffState,
  DropoffAppt,
  // fj
  IsOutbound,
  RefNum,
  Type,
  ClientCustName,
  ShipByDate,
  ShipDate,
  CancelDate,
  ShipNote,
  SalesOrderType,
  TypeRefNum,
  Commission,
  Commission2,
  DocumentDate,
  UpdateTime,
  FinalNetWeight,
  FinalShippingWeight,
  TotalPrice,
  FinalWeight,
  CarryType,
  Discount,
  Savings,
  ShippingCost,
  HandlingCost,
  SalesStatus,
  MiscCost,
  MiscNote,
  TaxAmount,
  TaxRate,
  FinalPrice,
  ConvertItemPrice,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Sales_User_id,
  Sales_User_id2,
  Picker_User_id,
  Packer_User_id,
  Creator_User_id,
  Product_id,
  Modifier_User_id,
  Notation,
  EmployeeNote,
  RouteNote,
  Note,
  TotalCRV,
  RefPrice,
  IsNoReduce,
  TrailerNum,
  Trailer,
  DSQID,
  CPO,
  LoadId,
  Type_wmb2b,
  Dept_wmb2b,
  //mag
  SaleStatus,
  delivery_address,
  delivery_eta,
  delivery_lfd,
  DeliveryStatus,
  cntrLocation,
  mag_note_other,
  DeliveryStatusOther,
  contact_person,
  contact_email,
  cntrNum,

  bolNum,
  shipping_line,
  size,
  cargo_weight,
  terminal,
  mag_note,
  OrderPalletQty,
  // cnt
  ShippingMethod,
  // fung, fv
  //TQ
  Company_id,
  PickAddress,
  ShipVia,
  IsLowerThanLowestPrice,
  IsOverCreditLimit,

  Email,
  Truck_CustomerDetail_id,

  // skh
  Channel,
  ETDate,
  Picker,
  Packer,
  //isVAK
  Req_Review_User_id,
  Req_Approve_User_id,
  Review_User_id,
  Approve_User_id,
  delivery_tracking_num,
  CommercialInvoice,
  Billing_CustomerDetail_id,
  Is_Prepay = false,
  Is_SynQB = false,
  CC,
}, additionalParams, extra) {
  if (Truck_CustomerDetail_id && Truck_CustomerDetail_id.value) {
    Truck_CustomerDetail_id = Truck_CustomerDetail_id.value;
  }
  if (SalesOrderType && SalesOrderType.value) {
    SalesOrderType = SalesOrderType.value;
  }
  if (isSV && !ShipDate) {
    ShipDate = new Date();
  }
  if (ShipVia && ShipVia.value) {
    ShipVia = ShipVia.value;
  }
  if (Company_id && Company_id.value) {
    Company_id = Company_id.value;
  }
  if (PaymentTerm_id && PaymentTerm_id.value) {
    PaymentTerm_id = PaymentTerm_id.value;
  }
  if (Agent_id && Agent_id.value) {
    Agent_id = Agent_id.value;
  }
  if (isFJ && Carrier && Carrier.value) {
    Carrier = Carrier.value;
  }
  if (DestinationAddress && DestinationAddress.value) {
    DestinationAddress = DestinationAddress.value;
  }
  if (PickupState && PickupState.value) {
    PickupState = PickupState.value;
  }
  if (DropoffState && DropoffState.value) {
    DropoffState = DropoffState.value;
  }
  if (ContainerSize && ContainerSize.value) {
    ContainerSize = ContainerSize.value;
  }
  if (ReceiveType && ReceiveType.value) {
    ReceiveType = ReceiveType.value;
  }
  if (ReceiveUnit && ReceiveUnit.value) {
    ReceiveUnit = ReceiveUnit.value;
  }
  if (isJTB && OrderType && OrderType.value) {
    OrderType = OrderType.value;
  }
  if (isMAG && SaleStatus && SaleStatus.value) {
    SaleStatus = SaleStatus.value;
  }
  if (isMAG && shipping_line && shipping_line.value) {
    shipping_line = shipping_line.value;
  }
  if (isMAG && terminal && terminal.value) {
    terminal = terminal.value;
  }
  if (isMAG && mag_note && mag_note.value) {
    mag_note = mag_note.value;
  }
  if (isMAG && size && size.value) {
    size = size.value;
  }
  if (DropshipType && DropshipType.value) {
    DropshipType = DropshipType.value;
  }
  if (!UpdateTime) UpdateTime = convertUtcDate();
  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
  if(isHMM) {
    Sales_Order_Lines = Sales_Order_Lines.map( line => {
      return {
        ...line,
        TotalPrice: line.Quantity * line.UnitPrice * line.PackageSize_1
      }
    })
  }
  if (isLAP || isOLG) {
    if (ShippingMethod && ShippingMethod.value) {
      ShippingMethod = ShippingMethod.value;
    }
  }
  if (isVAK) {
    if (Req_Review_User_id) {
      Req_Review_User_id = Req_Review_User_id.value;
    }
    if (Req_Approve_User_id) {
      Req_Approve_User_id = Req_Approve_User_id.value;
    }
    if (Review_User_id) {
      Review_User_id = Review_User_id.value;
    }
    if (Approve_User_id) {
      Approve_User_id = Approve_User_id.value;
    }
  }

  let dsqWT = false;
  if (isDSQ || isABCFF) {
    Sales_Order_Lines.map( (line,i) => {
      if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
        alert("Please enter either Box or Pallet quantity for each line.");
        dsqWT = true;
      }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (line.Quantity && (Number(line.Quantity) > 0)) {
          alert("A single product line cannot contain both Box and Pallet quantities.");
          dsqWT = true;
        }
      }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
          Sales_Order_Lines[i].Quantity = "1";
        }
      }
    });
    if (dsqWT) {
      return;
    }
  }

  if (isMAG) {
    Sales_Order_Lines = [
      {
        "ProductTax": 0,
        "CRV": 0,
        "Product_id": 1,
        "SalesOrderLine_id": 27,
        "ImageUrl": null,
        "RefPrice": 600,
        "RefNum": "",
        "TotalNetWeight": 1,
        "ProductType": "Fixed",
        "TotalShippingWeight": 0,
        "MeasureUnit": "LB",
        "TotalPrice": 600,
        "NetWeight": 1,
        "Description": "服务费",
        "PackageSize": "1case*1case",
        "PackageSize_1": "1",
        "IsTaxable": false,
        "Remark": null,
        "ProductDescription": "服务费",
        "Name": "service fee",
        "ProductNum": "01010001",
        "PackageType": "case",
        "Product_id_id": 1,
        "PickupQuantity": 0,
        "CostPrice": 0,
        "IsMobileLine": null,
        "Order": 1,
        "Quantity": 1,
        "IsForFree": false,
        "ProductName": "service fee",
        "SalesOrder_id_id": 27,
        "LoadedQuantity": 0,
        "Weights": null,
        "Batch_PONum": null,
        "UnitPrice": 600
      }
    ];
  }
  let data = {
    Truck_CustomerDetail_id,
    Delivery,
    HandlingFee,
    PercentageFee,
    TransFee,
    Surcharge,
    IsOverCreditLimit,
    IsLowerThanLowestPrice,
    IsRelocation,
    Sales_Order_Lines,
    Deliver_CustomerDetail_id,
    Deliver_Customer_id,
    IsWholesale,
    PaymentTerm_id,
    Agent_id,
    Pickup_Warehouse_id,
    OrderDate,
    ETADate,
    DispatchDate,
    DispatchStartTime,
    DispatchEndTime,
    PONum,
    // dsq
    OrderType,
    ContainerNum,
    IsFBAAddress,
    DestinationAddress,
    ISANum,
    Trucker,
    ReleaseDate,
    ReadyDate,
    OutboundDate,
    ShipmentID,
    OriginalPrice,
    Destination,
    ContainerSize,
    ISANote,
    DLNum,
    Carrier,
    Port,
    LFDate,
    IsDO,
    IsDirectShip,
    IsBOL,
    IsSeal,
    BOL,
    POD,
    IsPOD,
    FBARoute,
    ReceiveType,
    ReceiveUnit,
    DropshipType,
    Appointment,
    AppointmentDate,
    TruckingCo,
    DeliverTo,
    IsReturnEmpty,
    ArrivalDate,
    ReturnDate,
    StorageInDate,
    StorageOutDate,
    // dsq
    ExtInvoiceNum,
    Broker,
    Truckload,
    TruckNum,
    Dispatch,
    DetentionRate,
    LumperFee,
    PalletSpace,
    PickupDriver,
    PickupTrailerNum,
    PickupDate,
    PickupTime,
    PickupStreet,
    PickupZip,
    PickupCity,
    PickupState,
    PickupAppt,
    DropoffDriver,
    DropoffTrailerNum,
    DropoffDate,
    DropoffTime,
    DropoffStreet,
    DropoffZip,
    DropoffCity,
    DropoffState,
    DropoffAppt,
    //
    IsOutbound,
    RefNum,
    Type,
    ClientCustName,
    ShipByDate,
    ShipDate,
    CancelDate,
    ShipNote,
    SalesOrderType,
    TypeRefNum,
    Commission,
    Commission2,
    DocumentDate,
    UpdateTime,
    FinalNetWeight,
    FinalShippingWeight,
    TotalPrice,
    FinalWeight,
    CarryType,
    Discount,
    Savings,
    ShippingCost,
    HandlingCost,
    MiscCost,
    MiscNote,
    TaxAmount,
    TaxRate,
    SalesStatus,
    FinalPrice,
    ConvertItemPrice,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Sales_User_id,
    Sales_User_id2,
    Picker_User_id,
    Packer_User_id,
    Creator_User_id,
    Product_id,
    Modifier_User_id,
    Notation,
    EmployeeNote,
    RouteNote,
    Note,
    TotalCRV,
    RefPrice,
    IsNoReduce,
    TrailerNum,
    Trailer,
    DSQID,
    CPO,
    LoadId,
    Type_wmb2b,
    Dept_wmb2b,
    cntrNum,

    //mag
    SaleStatus,
    delivery_address,
    delivery_eta,
    delivery_lfd,
    DeliveryStatus,
    cntrLocation,
    mag_note_other,
    DeliveryStatusOther,
    contact_person,
    contact_email,

    bolNum,
    shipping_line,
    size,
    cargo_weight,
    terminal,
    mag_note,
    OrderPalletQty,
    // cnt
    ShippingMethod,
    // fung, fv
    //TQ
    Company_id,
    PickAddress,
    ShipVia,
    Email,
    // skh
    Channel,
    ETDate,
    Packer,
    //isVAK
    Req_Review_User_id,
    Req_Approve_User_id,
    Review_User_id,
    Approve_User_id,
    delivery_tracking_num,
    CommercialInvoice,
    ...additionalParams,
  }

  if(isOLG) {
    if(Billing_CustomerDetail_id) {
      data.Billing_CustomerDetail_id = Billing_CustomerDetail_id;
    }
    if(Picker && Picker.value) {
      data.Picker = Picker.value
    }
  }
  if(isSH) {
    data.CC = CC || 0;
  }
  if(isVAK) {
    data.Is_Prepay = Is_Prepay;
    data.Is_SynQB = Is_SynQB;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_ORDER });
    axios.post(
      (extra === 'invoice') ? `${SALES_SAVE_TO_INVOICE}` : `${SALES_ORDERS_URL}`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        // if (isSDR && response && response.data) {
        //   sendEmail(response.data.SalesOrder_id);
        // }
        dispatch(createSalesOrderSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createSalesOrderFailure(err));
      });
  };
}

export function createSalesOrderSuccess(order) {
  return {
    type: CREATE_SALES_ORDER_SUCCESS,
    payload: order,
  };
}

export function createSalesOrderFailure(error) {
  return {
    type: CREATE_SALES_ORDER_FAILURE,
    payload: error,
  };
}

export function editSalesOrder({
  IsRelocation,
  Sales_Order_Lines,
  SONum,
  Deliver_CustomerDetail_id,
  Deliver_Customer_id,
  Delivery,
  HandlingFee,
  PercentageFee,
  TransFee,
  Surcharge,
  IsWholesale,
  PaymentTerm_id,
  Agent_id,
  Pickup_Warehouse_id,
  OrderDate,
  ETADate,
  DispatchDate,
  DispatchStartTime,
  DispatchEndTime,
  PONum,
  // dsq
  OrderType,
  ContainerNum,
  IsFBAAddress,
  DestinationAddress,
  ISANum,
  Trucker,
  ReleaseDate,
  ReadyDate,
  OutboundDate,
  ShipmentID,
  OriginalPrice,
  Destination,
  ContainerSize,
  ISANote,
  DLNum,
  Carrier,
  Port,
  LFDate,
  IsDO,
  IsDirectShip,
  IsBOL,
  IsSeal,
  BOL,
  POD,
  IsPOD,
  FBARoute,
  ReceiveType,
  ReceiveUnit,
  DropshipType,
  Appointment,
  AppointmentDate,
  TruckingCo,
  DeliverTo,
  IsReturnEmpty,
  ArrivalDate,
  ReturnDate,
  StorageInDate,
  StorageOutDate,
  // dsq
  ExtInvoiceNum,
  Broker,
  Truckload,
  TruckNum,
  Dispatch,
  DetentionRate,
  LumperFee,
  PalletSpace,
  PickupDriver,
  PickupTrailerNum,
  PickupDate,
  PickupTime,
  PickupStreet,
  PickupZip,
  PickupCity,
  PickupState,
  PickupAppt,
  DropoffDriver,
  DropoffTrailerNum,
  DropoffDate,
  DropoffTime,
  DropoffStreet,
  DropoffZip,
  DropoffCity,
  DropoffState,
  DropoffAppt,
  // fj
  IsOutbound,
  RefNum,
  Type,
  ClientCustName,
  ShipByDate,
  ShipDate,
  CancelDate,
  ShipNote,
  SalesOrderType,
  TypeRefNum,
  Commission,
  Commission2,
  FinalNetWeight,
  TrailerNum,
  Trailer,
  DSQID,
  CPO,
  LoadId,
  Type_wmb2b,
  Dept_wmb2b,
  cntrNum,
  //mag
  SaleStatus,
  delivery_address,
  delivery_eta,
  delivery_lfd,
  DeliveryStatus,
  cntrLocation,
  mag_note_other,
  DeliveryStatusOther,
  contact_person,
  contact_email,
  bolNum,
  shipping_line,
  size,
  cargo_weight,
  terminal,
  mag_note,
  OrderPalletQty,
  // FinalShippingWeight,
  TotalCRV,
  TotalPrice,
  FinalWeight,
  CarryType,
  Discount,
  Savings,
  ShippingCost,
  HandlingCost,
  SalesStatus,
  MiscCost,
  MiscNote,
  TaxAmount,
  TaxRate,
  FinalPrice,
  ConvertItemPrice,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Sales_User_id,
  Sales_User_id2,
  Picker_User_id,
  Packer_User_id,
  Creator_User_id,
  Product_id,
  Modifier_User_id,
  Notation,
  // EmployeeNote,
  RouteNote,
  Note,
  RefPrice,
  IsNoReduce,
  Notes,
  // fung, fv
  //TQ
  Company_id,
  ShipVia,
  PickAddress,
  IsOverCreditLimit,
  IsLowerThanLowestPrice,
  Email,
  Truck_CustomerDetail_id,
  // skh
  Channel,
  ETDate,
  ShippingMethod,
  Picker,
  Packer,
  //isVAK
  Req_Review_User_id,
  Req_Approve_User_id,
  Review_User_id,
  Approve_User_id,
  delivery_tracking_num,
  CommercialInvoice,
  Billing_CustomerDetail_id,
  Is_Prepay = false,
  Is_SynQB = false,
  CC,
}, SalesOrder_id, additionalParams, extra) {
  if (Truck_CustomerDetail_id && Truck_CustomerDetail_id.value) {
    Truck_CustomerDetail_id = Truck_CustomerDetail_id.value
  }
  if (SalesOrderType && SalesOrderType.value) {
    SalesOrderType = SalesOrderType.value;
  }
  if (isSV && !ShipDate) {
    ShipDate = new Date();
  }
  if (ShipVia && ShipVia.value) {
    ShipVia = ShipVia.value;
  }
  if (Company_id && Company_id.value) {
    Company_id = Company_id.value;
  }
  if (PaymentTerm_id && PaymentTerm_id.value) {
    PaymentTerm_id = PaymentTerm_id.value;
  }
  if (isFJ && Carrier && Carrier.value) {
    Carrier = Carrier.value;
  }
  if (Agent_id && Agent_id.value) {
    Agent_id = Agent_id.value;
  }
  if (DestinationAddress && DestinationAddress.value) {
    DestinationAddress = DestinationAddress.value;
  }
  if (PickupState && PickupState.value) {
    PickupState = PickupState.value;
  }
  if (DropoffState && DropoffState.value) {
    DropoffState = DropoffState.value;
  }
  if (ContainerSize && ContainerSize.value) {
    ContainerSize = ContainerSize.value;
  }
  if (ReceiveType && ReceiveType.value) {
    ReceiveType = ReceiveType.value;
  }
  if (ReceiveUnit && ReceiveUnit.value) {
    ReceiveUnit = ReceiveUnit.value;
  }
  if (isJTB && OrderType && OrderType.value) {
    OrderType = OrderType.value;
  }
  if (isMAG && SaleStatus && SaleStatus.value) {
    SaleStatus = SaleStatus.value;
  }
  if (isMAG && shipping_line && shipping_line.value) {
    shipping_line = shipping_line.value;
  }
  if (isMAG && terminal && terminal.value) {
    terminal = terminal.value;
  }
  if (isMAG && mag_note && mag_note.value) {
    mag_note = mag_note.value;
  }
  if (isMAG && size && size.value) {
    size = size.value;
  }
  if (isLAP || isOLG) {
    if (ShippingMethod && ShippingMethod.value) {
      ShippingMethod = ShippingMethod.value;
    }
  }
  if (isVAK) {
    if (Req_Review_User_id) {
      Req_Review_User_id = Req_Review_User_id.value;
    }
    if (Req_Approve_User_id) {
      Req_Approve_User_id = Req_Approve_User_id.value;
    }
    if (Review_User_id) {
      Review_User_id = Review_User_id.value;
    }
    if (Approve_User_id) {
      Approve_User_id = Approve_User_id.value;
    }
  }
  let dsqWT = false;
  if (isDSQ || isABCFF) {
    Sales_Order_Lines.map( (line,i) => {
      if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
        alert("Please enter either Box or Pallet quantity for each line.");
        dsqWT = true;
      }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (line.Quantity && (Number(line.Quantity) > 0)) {
          alert("A single product line cannot contain both Box and Pallet quantities.");
          dsqWT = true;
        }
      }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
          Sales_Order_Lines[i].Quantity = "1";
        }
      }
    });
    if (dsqWT) {
      return;
    }
  }
  if (DropshipType && DropshipType.value) {
    DropshipType = DropshipType.value;
  }
  if (!OrderDate) OrderDate = convertUtcDate();
  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;

  let data =  {
    Truck_CustomerDetail_id,
    IsOverCreditLimit,
    IsLowerThanLowestPrice,
    ShipVia,
    PickAddress,
    IsRelocation,
    Sales_Order_Lines,
    SONum,
    Deliver_CustomerDetail_id,
    Deliver_Customer_id,
    Delivery,
    HandlingFee,
    PercentageFee,
    TransFee,
    Surcharge,
    IsWholesale,
    PaymentTerm_id,
    Agent_id,
    Pickup_Warehouse_id,
    OrderDate,
    ETADate,
    DispatchDate,
    DispatchStartTime,
    DispatchEndTime,
    PONum,
    // dsq
    OrderType,
    ContainerNum,
    IsFBAAddress,
    DestinationAddress,
    ISANum,
    Trucker,
    ReleaseDate,
    ReadyDate,
    OutboundDate,
    ShipmentID,
    OriginalPrice,
    Destination,
    ContainerSize,
    ISANote,
    DLNum,
    Carrier,
    Port,
    LFDate,
    IsDO,
    IsDirectShip,
    IsBOL,
    IsSeal,
    BOL,
    POD,
    IsPOD,
    FBARoute,
    ReceiveType,
    ReceiveUnit,
    DropshipType,
    Appointment,
    AppointmentDate,
    TruckingCo,
    DeliverTo,
    IsReturnEmpty,
    ArrivalDate,
    ReturnDate,
    StorageInDate,
    StorageOutDate,
    //
    ExtInvoiceNum,
    Broker,
    Truckload,
    TruckNum,
    Dispatch,
    DetentionRate,
    LumperFee,
    PalletSpace,
    PickupDriver,
    PickupTrailerNum,
    PickupDate,
    PickupTime,
    PickupStreet,
    PickupZip,
    PickupCity,
    PickupState,
    PickupAppt,
    DropoffDriver,
    DropoffTrailerNum,
    DropoffDate,
    DropoffTime,
    DropoffStreet,
    DropoffZip,
    DropoffCity,
    DropoffState,
    DropoffAppt,
    //
    IsOutbound,
    TrailerNum,
    Trailer,
    DSQID,
    CPO,
    LoadId,
    Type_wmb2b,
    Dept_wmb2b,
    cntrNum,

    //mag
    SaleStatus,
    delivery_address,
    delivery_eta,
    delivery_lfd,
    DeliveryStatus,
    cntrLocation,
    mag_note_other,
    DeliveryStatusOther,
    contact_person,
    contact_email,

    bolNum,
    shipping_line,
    size,
    cargo_weight,
    terminal,
    mag_note,
    OrderPalletQty,
    // dsq
    RefNum,
    Type,
    ClientCustName,
    ShipByDate,
    ShipDate,
    CancelDate,
    ShipNote,
    SalesOrderType,
    TypeRefNum,
    Commission,
    Commission2,
    FinalNetWeight,
    // FinalShippingWeight,
    TotalCRV,
    TotalPrice,
    FinalWeight,
    CarryType,
    Discount,
    Savings,
    ShippingCost,
    HandlingCost,
    SalesStatus,
    MiscCost,
    MiscNote,
    TaxAmount,
    TaxRate,
    FinalPrice,
    ConvertItemPrice,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Sales_User_id,
    Sales_User_id2,
    Picker_User_id,
    Packer_User_id,
    Creator_User_id,
    Product_id,
    Modifier_User_id,
    Notation,
    // EmployeeNote,
    RouteNote,
    Note,
    RefPrice,
    IsNoReduce,
    Notes,
    // fung, fv
    //TQ
    Company_id,
    Email,
    // skh
    Channel,
    ETDate,
    ShippingMethod,
    Packer,
    //isVAK
    Req_Review_User_id,
    Req_Approve_User_id,
    Review_User_id,
    Approve_User_id,
    delivery_tracking_num,
    CommercialInvoice,
    ...additionalParams,
  }
  if(isOLG) {
    if(Billing_CustomerDetail_id) {
      data.Billing_CustomerDetail_id = Billing_CustomerDetail_id;
    }
    if(Picker && Picker.value) {
      data.Picker = Picker.value
    }
  }
  if(isSH) {
    data.CC = CC || 0;
  }
  if(isVAK) {
    data.Is_Prepay = Is_Prepay;
    data.Is_SynQB = Is_SynQB;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_SALES_ORDER });
    axios.put(
      (extra === 'invoice') ? `${SALES_SAVE_TO_INVOICE + SalesOrder_id}` : `${SALES_ORDERS_URL + SalesOrder_id}`,
      // (SALES_ORDERS_URL + SalesOrder_id),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        // if (isSDR && response && response.data) {
        //   sendEmail(response.data.SalesOrder_id);
        // }
        dispatch(editSalesOrderSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editSalesOrderFailure(err));
      });
  };
}

export function editSalesOrderSuccess(order) {
  return {
    type: EDIT_SALES_ORDER_SUCCESS,
    payload: order,
  };
}

export function editSalesOrderFailure(error) {
  return {
    type: EDIT_SALES_ORDER_FAILURE,
    payload: error,
  };
}

export function voidSalesOrder(salesOrder_id, route, noJump = false) {
  return (dispatch) => {
    dispatch({ type: REQUEST_VOID_SALES_ORDER });
    axios.put(
      `${SALES_ORDERS_URL}cancel/${salesOrder_id.toString()}/`, {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(voidSalesOrderSuccess());
        if(noJump) return
        if (route === 'mobileSalesOrders') {
          browserHistory.push('/mobileSalesOrders');
        } else {
          browserHistory.push('/salesOrders');
        }
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(voidSalesOrderFailure(err));
      });
  };
}

function sendEmail(id) {
  axios.post(
    `${SEND_EMAIL}${id}`, 
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {

    }, (err) => {

    });
}

export function voidSalesOrderSuccess() {
  return {
    type: VOID_SALES_ORDER_SUCCESS,
  };
}

export function voidSalesOrderFailure(response) {
  return {
    type: VOID_SALES_ORDER_FAILURE,
    payload: response,
  };
}

export function fetchSalesQuotesLap() {
  return (dispatch) => {
    dispatch(requestSalesOrders());
    return axios.get(
      SALES_QUOTE_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrdersSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrdersFailure(err));
      });
  };
}

export function createSalesQuoteLap({
  Delivery,
  HandlingFee,
  PercentageFee,
  TransFee,
  Surcharge,
  IsRelocation,
  Sales_Quote_Lines,
  Deliver_CustomerDetail_id,
  Deliver_Customer_id,
  IsWholesale,
  PaymentTerm_id,
  Agent_id,
  Pickup_Warehouse_id,
  OrderDate,
  ETADate,
  DispatchDate,
  DispatchStartTime,
  DispatchEndTime,
  PONum,
  // dsq
  OrderType,
  ContainerNum,
  IsFBAAddress,
  DestinationAddress,
  ISANum,
  Trucker,
  ReleaseDate,
  ReadyDate,
  OutboundDate,
  ShipmentID,
  OriginalPrice,
  Destination,
  ContainerSize,
  ISANote,
  DLNum,
  Carrier,
  Port,
  LFDate,
  IsDO,
  IsDirectShip,
  IsBOL,
  IsSeal,
  BOL,
  POD,
  IsPOD,
  FBARoute,
  ReceiveType,
  ReceiveUnit,
  DropshipType,
  Appointment,
  AppointmentDate,
  TruckingCo,
  DeliverTo,
  IsReturnEmpty,
  ArrivalDate,
  ReturnDate,
  StorageInDate,
  StorageOutDate,
  // dsq
  ExtInvoiceNum,
  Broker,
  Truckload,
  TruckNum,
  Dispatch,
  DetentionRate,
  LumperFee,
  PalletSpace,
  PickupDriver,
  PickupTrailerNum,
  PickupDate,
  PickupTime,
  PickupStreet,
  PickupZip,
  PickupCity,
  PickupState,
  PickupAppt,
  DropoffDriver,
  DropoffTrailerNum,
  DropoffDate,
  DropoffTime,
  DropoffStreet,
  DropoffZip,
  DropoffCity,
  DropoffState,
  DropoffAppt,
  // fj
  IsOutbound,
  RefNum,
  Type,
  ClientCustName,
  ShipByDate,
  ShipDate,
  CancelDate,
  ShipNote,
  Commission,
  Commission2,
  DocumentDate,
  UpdateTime,
  FinalNetWeight,
  FinalShippingWeight,
  TotalPrice,
  FinalWeight,
  CarryType,
  Discount,
  Savings,
  ShippingCost,
  HandlingCost,
  SalesStatus,
  MiscCost,
  MiscNote,
  TaxAmount,
  TaxRate,
  FinalPrice,
  ConvertItemPrice,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Sales_User_id,
  Sales_User_id2,
  Picker_User_id,
  Packer_User_id,
  Creator_User_id,
  Product_id,
  Modifier_User_id,
  Notation,
  EmployeeNote,
  RouteNote,
  Note,
  TotalCRV,
  RefPrice,
  IsNoReduce,
  TrailerNum,
  Trailer,
  DSQID,
  CPO,
  LoadId,
  Type_wmb2b,
  Dept_wmb2b,
  //mag
  SaleStatus,
  delivery_address,
  delivery_eta,
  delivery_lfd,
  DeliveryStatus,
  cntrLocation,
  mag_note_other,
  DeliveryStatusOther,
  contact_person,
  contact_email,
  cntrNum,

  bolNum,
  shipping_line,
  size,
  cargo_weight,
  terminal,
  mag_note,
  OrderPalletQty,
  // cnt
  ShippingMethod,
  // fung, fv
  //TQ
  Company_id,
  PickAddress,
  ShipVia,
  IsLowerThanLowestPrice,
  IsOverCreditLimit,

  Email,
  Truck_CustomerDetail_id,

  // skh
  Channel,
  ExpirDate,
}, additionalParams) {
  if (Truck_CustomerDetail_id && Truck_CustomerDetail_id.value) {
    Truck_CustomerDetail_id = Truck_CustomerDetail_id.value;
  }
  if (ShipVia && ShipVia.value) {
    ShipVia = ShipVia.value;
  }
  if (Company_id && Company_id.value) {
    Company_id = Company_id.value;
  }
  if (PaymentTerm_id && PaymentTerm_id.value) {
    PaymentTerm_id = PaymentTerm_id.value;
  }
  if (Agent_id && Agent_id.value) {
    Agent_id = Agent_id.value;
  }
  if (DestinationAddress && DestinationAddress.value) {
    DestinationAddress = DestinationAddress.value;
  }
  if (PickupState && PickupState.value) {
    PickupState = PickupState.value;
  }
  if (DropoffState && DropoffState.value) {
    DropoffState = DropoffState.value;
  }
  if (ContainerSize && ContainerSize.value) {
    ContainerSize = ContainerSize.value;
  }
  if (ReceiveType && ReceiveType.value) {
    ReceiveType = ReceiveType.value;
  }
  if (ReceiveUnit && ReceiveUnit.value) {
    ReceiveUnit = ReceiveUnit.value;
  }
  if (DropshipType && DropshipType.value) {
    DropshipType = DropshipType.value;
  }
  if (!UpdateTime) UpdateTime = convertUtcDate();
  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;

  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_QUOTE });
    axios.post(
      `${SALES_QUOTE_URL}`,
      {
        Truck_CustomerDetail_id,
        Delivery,
        HandlingFee,
        PercentageFee,
        TransFee,
        Surcharge,
        IsOverCreditLimit,
        IsLowerThanLowestPrice,
        IsRelocation,
        Sales_Quote_Lines,
        Deliver_CustomerDetail_id,
        Deliver_Customer_id,
        IsWholesale,
        PaymentTerm_id,
        Agent_id,
        Pickup_Warehouse_id,
        OrderDate,
        ETADate,
        DispatchDate,
        DispatchStartTime,
        DispatchEndTime,
        PONum,
        // dsq
        OrderType,
        ContainerNum,
        IsFBAAddress,
        DestinationAddress,
        ISANum,
        Trucker,
        ReleaseDate,
        ReadyDate,
        OutboundDate,
        ShipmentID,
        OriginalPrice,
        Destination,
        ContainerSize,
        ISANote,
        DLNum,
        Carrier,
        Port,
        LFDate,
        IsDO,
        IsDirectShip,
        IsBOL,
        IsSeal,
        BOL,
        POD,
        IsPOD,
        FBARoute,
        ReceiveType,
        ReceiveUnit,
        DropshipType,
        Appointment,
        AppointmentDate,
        TruckingCo,
        DeliverTo,
        IsReturnEmpty,
        ArrivalDate,
        ReturnDate,
        StorageInDate,
        StorageOutDate,
        // dsq
        ExtInvoiceNum,
        Broker,
        Truckload,
        TruckNum,
        Dispatch,
        DetentionRate,
        LumperFee,
        PalletSpace,
        PickupDriver,
        PickupTrailerNum,
        PickupDate,
        PickupTime,
        PickupStreet,
        PickupZip,
        PickupCity,
        PickupState,
        PickupAppt,
        DropoffDriver,
        DropoffTrailerNum,
        DropoffDate,
        DropoffTime,
        DropoffStreet,
        DropoffZip,
        DropoffCity,
        DropoffState,
        DropoffAppt,
        //
        IsOutbound,
        RefNum,
        Type,
        ClientCustName,
        ShipByDate,
        ShipDate,
        CancelDate,
        ShipNote,
        Commission,
        Commission2,
        DocumentDate,
        UpdateTime,
        FinalNetWeight,
        FinalShippingWeight,
        TotalPrice,
        FinalWeight,
        CarryType,
        Discount,
        Savings,
        ShippingCost,
        HandlingCost,
        MiscCost,
        MiscNote,
        TaxAmount,
        TaxRate,
        SalesStatus,
        FinalPrice,
        ConvertItemPrice,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Sales_User_id,
        Sales_User_id2,
        Picker_User_id,
        Packer_User_id,
        Creator_User_id,
        Product_id,
        Modifier_User_id,
        Notation,
        EmployeeNote,
        RouteNote,
        Note,
        TotalCRV,
        RefPrice,
        IsNoReduce,
        TrailerNum,
        Trailer,
        DSQID,
        CPO,
        LoadId,
        Type_wmb2b,
        Dept_wmb2b,
        cntrNum,

        //mag
        SaleStatus,
        delivery_address,
        delivery_eta,
        delivery_lfd,
        DeliveryStatus,
        cntrLocation,
        mag_note_other,
        DeliveryStatusOther,
        contact_person,
        contact_email,

        bolNum,
        shipping_line,
        size,
        cargo_weight,
        terminal,
        mag_note,
        OrderPalletQty,
        // cnt
        ShippingMethod,
        // fung, fv
        //TQ
        Company_id,
        PickAddress,
        ShipVia,
        Email,
        // skh
        Channel,
        ExpirDate,
        ...additionalParams,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createSalesOrderSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createSalesOrderFailure(err));
      });
  };
}

export function editSalesQuoteLap({
  IsRelocation,
  Sales_Quote_Lines,
  SQNum,
  Deliver_CustomerDetail_id,
  Deliver_Customer_id,
  Delivery,
  HandlingFee,
  PercentageFee,
  TransFee,
  Surcharge,
  IsWholesale,
  PaymentTerm_id,
  Agent_id,
  Pickup_Warehouse_id,
  OrderDate,
  ETADate,
  DispatchDate,
  DispatchStartTime,
  DispatchEndTime,
  PONum,
  // dsq
  OrderType,
  ContainerNum,
  IsFBAAddress,
  DestinationAddress,
  ISANum,
  Trucker,
  ReleaseDate,
  ReadyDate,
  OutboundDate,
  ShipmentID,
  OriginalPrice,
  Destination,
  ContainerSize,
  ISANote,
  DLNum,
  Carrier,
  Port,
  LFDate,
  IsDO,
  IsDirectShip,
  IsBOL,
  IsSeal,
  BOL,
  POD,
  IsPOD,
  FBARoute,
  ReceiveType,
  ReceiveUnit,
  DropshipType,
  Appointment,
  AppointmentDate,
  TruckingCo,
  DeliverTo,
  IsReturnEmpty,
  ArrivalDate,
  ReturnDate,
  StorageInDate,
  StorageOutDate,
  // dsq
  ExtInvoiceNum,
  Broker,
  Truckload,
  TruckNum,
  Dispatch,
  DetentionRate,
  LumperFee,
  PalletSpace,
  PickupDriver,
  PickupTrailerNum,
  PickupDate,
  PickupTime,
  PickupStreet,
  PickupZip,
  PickupCity,
  PickupState,
  PickupAppt,
  DropoffDriver,
  DropoffTrailerNum,
  DropoffDate,
  DropoffTime,
  DropoffStreet,
  DropoffZip,
  DropoffCity,
  DropoffState,
  DropoffAppt,
  // fj
  IsOutbound,
  RefNum,
  Type,
  ClientCustName,
  ShipByDate,
  ShipDate,
  CancelDate,
  ShipNote,
  Commission,
  Commission2,
  FinalNetWeight,
  TrailerNum,
  Trailer,
  DSQID,
  CPO,
  LoadId,
  Type_wmb2b,
  Dept_wmb2b,
  cntrNum,
  //mag
  SaleStatus,
  delivery_address,
  delivery_eta,
  delivery_lfd,
  DeliveryStatus,
  cntrLocation,
  mag_note_other,
  DeliveryStatusOther,
  contact_person,
  contact_email,
  bolNum,
  shipping_line,
  size,
  cargo_weight,
  terminal,
  mag_note,
  OrderPalletQty,
  // FinalShippingWeight,
  TotalCRV,
  TotalPrice,
  FinalWeight,
  CarryType,
  Discount,
  Savings,
  ShippingCost,
  HandlingCost,
  SalesStatus,
  MiscCost,
  MiscNote,
  TaxAmount,
  TaxRate,
  FinalPrice,
  ConvertItemPrice,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Sales_User_id,
  Sales_User_id2,
  Picker_User_id,
  Packer_User_id,
  Creator_User_id,
  Product_id,
  Modifier_User_id,
  Notation,
  // EmployeeNote,
  RouteNote,
  Note,
  RefPrice,
  Notes,
  // fung, fv
  //TQ
  Company_id,
  ShipVia,
  PickAddress,
  IsOverCreditLimit,
  IsLowerThanLowestPrice,
  Email,
  Truck_CustomerDetail_id,
  // skh
  Channel,
  ExpirDate,
}, SalesQuote_id, additionalParams) {
  if (Truck_CustomerDetail_id && Truck_CustomerDetail_id.value) {
    Truck_CustomerDetail_id = Truck_CustomerDetail_id.value
  }
  if (ShipVia && ShipVia.value) {
    ShipVia = ShipVia.value;
  }
  if (Company_id && Company_id.value) {
    Company_id = Company_id.value;
  }
  if (PaymentTerm_id && PaymentTerm_id.value) {
    PaymentTerm_id = PaymentTerm_id.value;
  }
  if (Agent_id && Agent_id.value) {
    Agent_id = Agent_id.value;
  }
  if (DestinationAddress && DestinationAddress.value) {
    DestinationAddress = DestinationAddress.value;
  }
  if (PickupState && PickupState.value) {
    PickupState = PickupState.value;
  }
  if (DropoffState && DropoffState.value) {
    DropoffState = DropoffState.value;
  }
  if (ContainerSize && ContainerSize.value) {
    ContainerSize = ContainerSize.value;
  }
  if (ReceiveType && ReceiveType.value) {
    ReceiveType = ReceiveType.value;
  }
  if (ReceiveUnit && ReceiveUnit.value) {
    ReceiveUnit = ReceiveUnit.value;
  }

  if (DropshipType && DropshipType.value) {
    DropshipType = DropshipType.value;
  }
  if (!OrderDate) OrderDate = convertUtcDate();
  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_SALES_ORDER });
    axios.put(
      `${SALES_QUOTE_URL + SalesQuote_id}`,
      {
        Truck_CustomerDetail_id,
        IsOverCreditLimit,
        IsLowerThanLowestPrice,
        ShipVia,
        PickAddress,
        IsRelocation,
        Sales_Quote_Lines,
        SQNum,
        Deliver_CustomerDetail_id,
        Deliver_Customer_id,
        Delivery,
        HandlingFee,
        PercentageFee,
        TransFee,
        Surcharge,
        IsWholesale,
        PaymentTerm_id,
        Agent_id,
        Pickup_Warehouse_id,
        OrderDate,
        ETADate,
        DispatchDate,
        DispatchStartTime,
        DispatchEndTime,
        PONum,
        // dsq
        OrderType,
        ContainerNum,
        IsFBAAddress,
        DestinationAddress,
        ISANum,
        Trucker,
        ReleaseDate,
        ReadyDate,
        OutboundDate,
        ShipmentID,
        OriginalPrice,
        Destination,
        ContainerSize,
        ISANote,
        DLNum,
        Carrier,
        Port,
        LFDate,
        IsDO,
        IsDirectShip,
        IsBOL,
        IsSeal,
        BOL,
        POD,
        IsPOD,
        FBARoute,
        ReceiveType,
        ReceiveUnit,
        DropshipType,
        Appointment,
        AppointmentDate,
        TruckingCo,
        DeliverTo,
        IsReturnEmpty,
        ArrivalDate,
        ReturnDate,
        StorageInDate,
        StorageOutDate,
        //
        ExtInvoiceNum,
        Broker,
        Truckload,
        TruckNum,
        Dispatch,
        DetentionRate,
        LumperFee,
        PalletSpace,
        PickupDriver,
        PickupTrailerNum,
        PickupDate,
        PickupTime,
        PickupStreet,
        PickupZip,
        PickupCity,
        PickupState,
        PickupAppt,
        DropoffDriver,
        DropoffTrailerNum,
        DropoffDate,
        DropoffTime,
        DropoffStreet,
        DropoffZip,
        DropoffCity,
        DropoffState,
        DropoffAppt,
        //
        IsOutbound,
        TrailerNum,
        Trailer,
        DSQID,
        CPO,
        LoadId,
        Type_wmb2b,
        Dept_wmb2b,
        cntrNum,

        //mag
        SaleStatus,
        delivery_address,
        delivery_eta,
        delivery_lfd,
        DeliveryStatus,
        cntrLocation,
        mag_note_other,
        DeliveryStatusOther,
        contact_person,
        contact_email,

        bolNum,
        shipping_line,
        size,
        cargo_weight,
        terminal,
        mag_note,
        OrderPalletQty,
        // dsq
        RefNum,
        Type,
        ClientCustName,
        ShipByDate,
        ShipDate,
        CancelDate,
        ShipNote,
        Commission,
        Commission2,
        FinalNetWeight,
        // FinalShippingWeight,
        TotalCRV,
        TotalPrice,
        FinalWeight,
        CarryType,
        Discount,
        Savings,
        ShippingCost,
        HandlingCost,
        SalesStatus,
        MiscCost,
        MiscNote,
        TaxAmount,
        TaxRate,
        FinalPrice,
        ConvertItemPrice,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Sales_User_id,
        Sales_User_id2,
        Picker_User_id,
        Packer_User_id,
        Creator_User_id,
        Product_id,
        Modifier_User_id,
        Notation,
        // EmployeeNote,
        RouteNote,
        Note,
        RefPrice,
        Notes,
        // fung, fv
        //TQ
        Company_id,
        Email,
        // skh
        Channel,
        ExpirDate,
        ...additionalParams,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editSalesOrderSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editSalesOrderFailure(err));
      });
  };
}

export function voidSalesQuoteLap(salesQuote_id, route) {
  return (dispatch) => {
    dispatch({ type: REQUEST_VOID_SALES_ORDER });
    axios.put(
      `${SALES_QUOTE_URL}cancel/${salesQuote_id}/`, {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(voidSalesOrderSuccess());
        browserHistory.push('/salesQuotes');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(voidSalesOrderFailure(err));
      });
  };
}

export function printSalesQuoteLap(salesOrder_id, status) {
  let url = SALES_QUOTE_LAP_PRINT_URL + salesOrder_id;
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function fetchSalesQuoteDetailLap(salesQuote_id, route, isRefresh = false) {
  const apiUrl = SALES_QUOTE_URL;
  let url = `${apiUrl}?pk=${salesQuote_id}`;
  if (isRefresh) {
    url += '&refresh=1';
  }
  return (dispatch) => {
    dispatch(requestSalesOrderDetail());
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesQuoteDetailLapSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailFailure(err));
      });
  };
}

export function fetchSalesQuoteDetailLapSuccess(salesQuoteDetail) {
  salesQuoteDetail = { ...salesQuoteDetail.data };
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesQuoteDetail.OrderDate) salesQuoteDetail.OrderDate = convertUtcDate(salesQuoteDetail.OrderDate);
  if (salesQuoteDetail.ETADate) salesQuoteDetail.ETADate = convertUtcDate(salesQuoteDetail.ETADate);
  if (salesQuoteDetail.ReceivedDate) salesQuoteDetail.ReceivedDate = convertUtcDate(salesQuoteDetail.ReceivedDate);
  if (salesQuoteDetail.DispatchDate) salesQuoteDetail.DispatchDate = convertUtcDate(salesQuoteDetail.DispatchDate);

  if (salesQuoteDetail.ShippingMethod) {
    const array = salesQuoteDetail.ShippingMethod.split('/');
    if (array.length===1) {
      salesQuoteDetail.shipMethod = salesQuoteDetail.ShippingMethod.split('/')[0];
    } else {
      salesQuoteDetail.shipCarrier = salesQuoteDetail.ShippingMethod.split('/')[0];
      salesQuoteDetail.shipMethod = salesQuoteDetail.ShippingMethod.split('/')[1];
    }
  }

  salesQuoteDetail.Sales_Quote_Lines = salesQuoteDetail.Sales_Quote_Lines.map(line => {
    return {
      ...line,
      originQty: line.Quantity,
    }
  })
  return {
    type: FETCH_SALES_ORDER_DETAIL_SUCCESS,
    payload: salesQuoteDetail,
  };
}

export function fetchSalesQuoteCustomerDetailLap(pk, SalesOrder_id, isShippingCustomer, cb) {
  const url = SALES_QUOTE_CUSTOMER_URL + ((SalesOrder_id) ? (`${SalesOrder_id}/order`) : pk);
  return (dispatch) => {
    if (isShippingCustomer) {
      dispatch({ type: REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL });
    } else {
      dispatch({ type: REQUEST_SALES_CUSTOMER_DETAIL });
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        if (isShippingCustomer) {
          cb && cb(response);
          dispatch(fetchShippingCustomerDetailSuccess(response));
        } else {
          dispatch(fetchSalesCustomerDetailSuccess(response));
        }
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesCustomerDetailFailure(err));
      });
  };
}

// fetch SO customer sales history
export function requestCustomerSalesHistory() {
  return {
    type: REQUEST_CUSTOMER_SALES_HISTORY,
  };
}

export function fetchCustomerSalesHistorySuccess(history) {
  return {
    type: FETCH_CUSTOMER_SALES_HISTORY_SUCCESS,
    payload: history,
  };
}

export function fetchCustomerSalesHistoryFailure(error) {
  return {
    type: FETCH_CUSTOMER_SALES_HISTORY_FAILURE,
    payload: error,
  };
}

export function fetchCustomerSalesHistory(customerId) {
  return (dispatch) => {
    dispatch(requestCustomerSalesHistory());
    return axios.get(
      `${CUSTOMER_SALES_HISTORY}${customerId}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerSalesHistorySuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerSalesHistoryFailure(err));
      });
  };
}

export function createSO(salesOrderId) {
  return axios.post(
    `${CREATE_PR_URL}${salesOrderId}`,
    {
    },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      if(response.status === 200){
        alert(I18n.t('create_pr_success'))
      }
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else {
        alert(err.data)
      }
    });
}

// fetch SO customer order sc
export function fetchCustomerOrderSchedules() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_ORDER_SCHEDULES });
    axios.get(
      SALES_DASHBOARD_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerOrderSchedulesSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerOrderSchedulesFailure(err));
      });
  };
}

export function fetchCustomerOrderSchedulesByDate(date) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_ORDER_SCHEDULES });
    axios.get(
      SALES_DASHBOARD_URL + date,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerOrderSchedulesSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerOrderSchedulesFailure(err));
      });
  };
}

export function fetchCustomerOrderSchedulesSuccess(orderSchedules) {
  return {
    type: FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS,
    payload: orderSchedules,
  };
}

export function fetchCustomerOrderSchedulesFailure(error) {
  return {
    type: FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE,
    payload: error,
  };
}

export function fetchTodaysOutgoingOrders() {
  return (dispatch) => {
    dispatch(requestTodaysOutgoingOrders());
    return axios.get(
      OUTGOING_ORDERS_BY_DATE_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchTodaysOutgoingOrdersSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchTodaysOutgoingOrdersFailure(err));
      });
  };
}

export function requestTodaysOutgoingOrders() {
  return {
    type: REQUEST_TODAYS_OUTGOING_ORDERS,
  };
}

export function fetchTodaysOutgoingOrdersSuccess(orders) {
  return {
    type: FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS,
    payload: orders,
  };
}

export function fetchTodaysOutgoingOrdersFailure(error) {
  return {
    type: FETCH_TODAYS_OUTGOING_ORDERS_FAILURE,
    payload: error,
  };
}

export const podUpload = (salesorderId, data, success) => {
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v1/sale/upload-pod-file/${salesorderId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    success();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert('error uploading pod file');
  });
}

export function fetchOutgoingOrdersByDate({ fromDate, toDate, selectedCompany, selectedWarehouse, isPastSo = false,  order = 'ETDate' }) {
  return (dispatch) => {
    dispatch(requestTodaysOutgoingOrders());
    let url = OUTGOING_ORDERS_BY_DATE_URL;
    if(isGGI && selectedWarehouse && selectedWarehouse != undefined && selectedWarehouse != null) {
      url = OUTGOING_ORDERS_BY_DATE_URL + selectedWarehouse;
    }
    let data = isGGI ? {
      start_date: fromDate,
      end_date: toDate,
      Company_id: selectedCompany,
    } : {
      start_date: fromDate,
      end_date: toDate,
    }
    if(isLAP) {
      let timeZone = new Date().getTimezoneOffset();
      if(isPastSo) {
        url = DASHBOARD_SO_PAST_URL;
        data = {
          order,
          companyId: selectedCompany,
          warehouseId: selectedWarehouse,
          timeZoneOffSet: timeZone,
        }
      } else {
        data = {
          start_date: fromDate,
          end_date: toDate,
          companyId: selectedCompany,
          warehouseId: selectedWarehouse,
        }
      }
    }
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: data,
    }).then((response) => {
      dispatch(fetchTodaysOutgoingOrdersSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchTodaysOutgoingOrdersFailure(err));
    });
  };
}

export function fetchSalesOrderLineWeights(line_id) {
  return (dispatch) => {
    dispatch(requestSalesOrderLineWeights());
    return axios.get(
      SALES_ORDER_LINE_WEIGHTS_URL + line_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderLineWeightsSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderLineWeightsFailure(err));
      });
  };
}

export function requestSalesOrderLineWeights() {
  return {
    type: REQUEST_SALES_ORDER_LINE_WEIGHTS,
  };
}

export function fetchSalesOrderLineWeightsSuccess(weights) {
  return {
    type: FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
    payload: weights,
  };
}

export function fetchSalesOrderLineWeightsFailure(error) {
  return {
    type: FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE,
    payload: error,
  };
}

export function setOrderLineWeights(line_id, lines, isAction = false) {
  const Weights = [];
  lines.map((row) => {
    Weights.push(parseFloat(row.Weight));
  });
  let data = {
    Weights,
  }
  if(isAction) {
    data.action = 'invoice';
  }
  return (dispatch) => {
    dispatch(requestSetOrderLineWeights());
    return axios.post(
      SALES_ORDER_LINE_WEIGHTS_URL + line_id,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editSalesOrderLineWeightsSuccess());
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editSalesOrderLineWeightsFailure(err));
      });
  };
}

export function requestSetOrderLineWeights() {
  return {
    type: REQUEST_SET_ORDER_LINE_WEIGHTS,
  };
}

export function editSalesOrderLineWeightsSuccess() {
  return {
    type: EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
  };
}

export function editSalesOrderLineWeightsFailure(error) {
  return {
    type: EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE,
    payload: error,
  };
}

export function clearSalesOrderLineWeights() {
  return {
    type: CLEAR_SALES_ORDER_LINE_WEIGHTS,
  };
}

export function fetchSalesOrderForm() {
  return (dispatch) => {
    dispatch(requestSalesOrderForm());
    return axios.get(
      FETCH_SALES_ORDER_FORM_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderFormSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderFormFailure(err));
      });
  };
}

export function requestSalesOrderForm() {
  return {
    type: REQUEST_SALES_ORDER_FORM,
  };
}

export function fetchSalesOrderFormSuccess(form) {
  return {
    type: FETCH_SALES_ORDER_FORM_SUCCESS,
    payload: form,
  };
}

export function fetchSalesOrderFormFailure(error) {
  return {
    type: FETCH_SALES_ORDER_FORM_FAILURE,
    payload: error,
  };
}

export function clearInventories() {
  return {
    type: CLEAR_INVENTORIES,
  };
}

export function fetchSalesCSV() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_CSV });
    return axios.post(
      `${ROOT_URL}v1/dashboard/salesiif/`,
      // DASHBOARD_URL + 'salescsv/',
      {
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesCSVSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesCSVFailure(err));
      });
  };
}

export function fetchSalesCSVSuccess(form) {
  return {
    type: FETCH_SALES_CSV_SUCCESS,
    payload: form,
  };
}

export function fetchSalesCSVFailure(error) {
  return {
    type: FETCH_SALES_CSV_FAILURE,
    payload: error,
  };
}

export function savePosSale({
  Order_id,
  Order_Num,
  Subtotal,
  FinalPrice,
  TaxRate,
  Sales_User,
  Warehouse_id,
  Note,
  POS_Order_Lines,
  SaleStatus,
}) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SAVE_POS_SALE });
    return axios.post(
      POS_SALE_URL,
      {
        Order_id,
        Order_Num,
        Subtotal,
        FinalPrice,
        TaxRate,
        Sales_User,
        Warehouse_id,
        Note,
        POS_Order_Lines,
        SaleStatus,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(change('pos', 'ProductNum', ''));
        dispatch(change('pos', 'Quantity', ''));
        dispatch(change('pos', 'CashCharge', ''));
        dispatch(change('pos', 'CheckCharge', ''));
        dispatch(change('pos', 'CreditCharge', ''));
        dispatch(change('pos', 'FinalCharge', ''));
        dispatch(savePosSaleSuccessful(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(savePosSaleFailure(err));
      });
  };
}

export function savePosSaleSuccessful(response) {
  return {
    type: SAVE_POS_SALE_SUCCESS,
  };
}

export function savePosSaleFailure(error) {
  return {
    type: SAVE_POS_SALE_FAILURE,
    payload: error,
  };
}

export function invalidCharacterEntered() {
  return {
    type: INVALID_CHARACTER_ENTERED,
  };
}

export function chargeNotMet() {
  return {
    type: CHARGE_NOT_MET,
  };
}

export function clearErrorMessageInPOS() {
  return {
    type: CLEAR_ERROR_MESSAGE_IN_POS,
  };
}

export function startNewOrder() {
  return {
    type: START_NEW_ORDER,
  };
}

export function startNewItem() {
  return (dispatch) => {
    dispatch(change('pos', 'ProductNum', ''));
    dispatch(change('pos', 'Quantity', ''));
  };
}

export function setSaleRowValue(CustomerLevel, form, row) {
  return (dispatch) => {
    dispatch(change(form, 'UnitPrice', row[`PriceLv${CustomerLevel}`] ? row[`PriceLv${CustomerLevel}`] : row.Price));
    dispatch(change(form, 'Weight', row.NetWeight));
  };
}

export function setSaleOrderProductValues(CustomerPrice, form, product) {
  return (dispatch) => {
    dispatch(change(form, 'UnitPrice', CustomerPrice));
    dispatch(change(form, 'Weight', product.NetWeight));
    dispatch(change(form, 'BaseCost', product.BaseCost));
    dispatch(change(form, 'ProductCost', product.ProductCost));
    dispatch(change(form, 'PackageSize_1', product.PackageSize_1));
  };
}

export function setSaleFavoriteRowValue(title, form, row) {
  return (dispatch) => {
    dispatch(change(form, 'ProductInformation', title));
  };
}

export function setCredit(value) {
  return (dispatch) => {
    dispatch(change('salesOrderForm', 'creditRadios', value));
  };
}

export function setSubtotal(value) {
  return (dispatch) => {
    dispatch(change('salesOrderForm', 'Subtotal', value));
  };
}

export function resetFormInputs() {
  return (dispatch) => {
    dispatch(change('salesOrderForm', 'Quantity', '1'));
    dispatch(change('salesOrderForm', 'UnitPrice', ''));
    dispatch(change('salesOrderForm', 'SmallUnitPrice', ''));
    dispatch(change('salesOrderForm', 'ProductInformation', ''));
    dispatch(change('salesOrderForm', 'Weight', ''));
    dispatch(change('salesOrderForm', 'itemNotation', ''));
    dispatch(change('salesOrderForm', 'ProductCost', ''));
    dispatch(change('salesOrderForm', 'LineDiscount', ''));

    dispatch(change('salesOrderForm', 'ReceivedQuantity', ''));
    dispatch(change('salesOrderForm', 'ShipmentID', ''));
    dispatch(change('salesOrderForm', 'OriginalPrice', ''));
    dispatch(change('salesOrderForm', 'BillablePallets', ''));
    dispatch(change('salesOrderForm', 'PalletQuantity', ''));

    dispatch(change('salesOrderForm', 'Sqft', ''));
    dispatch(change('salesOrderForm', 'SqftPack', ''));
    dispatch(change('salesOrderForm', 'SqftTotal', ''));

    dispatch(change('salesOrderForm', 'BoxQuantity', ''));
    dispatch(change('salesOrderForm', 'PieceQuantity', ''));
    dispatch(change('salesOrderForm', 'RealPallets', ''));
    dispatch(change('salesOrderForm', 'BoxPerPallet', ''));
    dispatch(change('salesOrderForm', 'FBACode', ''));
    dispatch(change('salesOrderForm', 'DispatchType', ''));
    dispatch(change('salesOrderForm', 'BoxVol', ''));
    dispatch(change('salesOrderForm', 'BoxLength', ''));
    dispatch(change('salesOrderForm', 'BoxWidth', ''));
    dispatch(change('salesOrderForm', 'BoxHeight', ''));
    dispatch(change('salesOrderForm', 'InnerLabelQty', ''));
    dispatch(change('salesOrderForm', 'OuterLabelQty', ''));

    dispatch(change('salesOrderForm', 'BoxWeight', ''));
    dispatch(change('salesOrderForm', 'PalletLength', ''));
    dispatch(change('salesOrderForm', 'PalletWidth', ''));
    dispatch(change('salesOrderForm', 'PalletHeight', ''));
    dispatch(change('salesOrderForm', 'PalletVol', ''));
    dispatch(change('salesOrderForm', 'PalletWeight', ''));
    dispatch(change('salesOrderForm', 'IsOversize', ''));
    dispatch(change('salesOrderForm', 'IsOverweight', ''));
    dispatch(change('salesOrderForm', 'PortDray', ''));
    dispatch(change('salesOrderForm', 'DrayageTrucker', ''));
    dispatch(change('salesOrderForm', 'TotalShippingWeight', 0));
    dispatch(change('salesOrderForm', 'Location', ''));

    dispatch(change('salesOrderForm', 'FBARoute', ''));
    dispatch(change('salesOrderForm', 'DimUnit', ''));
    dispatch(change('salesOrderForm', 'IsNoReturn', ''));
    // dispatch(change('salesOrderForm', 'IsCombo', ''));
    dispatch(change('salesOrderForm', 'IsChild', false));
    dispatch(change('salesOrderForm', 'WeightUnit', ''));
    dispatch(change('salesOrderForm', 'TrailerNum', ''));
    dispatch(change('salesOrderForm', 'POList', ''));
    dispatch(change('salesOrderForm', 'POD', ''));
  };
}

export function setValue(form, field, value) {
  return (dispatch) => {
    dispatch(change(form, field, value));
  };
}

export function fetchPOSDraft(pk) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DRAFT_DETAILS });
    return axios.get(
      POS_SALE_URL + pk,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchDraftDetailsSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchDraftDetailsFailure(err));
      });
  };
}

export function fetchDraftDetailsSuccess(details) {
  return {
    type: LOAD_DRAFT_SUCCESS,
    payload: details,
  };
}

export function fetchDraftDetailsFailure(error) {
  return {
    type: LOAD_DRAFT_FAILURE,
    payload: error,
  };
}

export function fetchDrafts() {
  return (dispatch) => {
    dispatch({ type: REQUEST_DRAFTS });
    return axios.get(
      `${POS_SALE_URL}draft`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchDraftsSuccessful(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchDraftsFailure(err));
      });
  };
}

export function fetchDraftsSuccessful(drafts) {
  return {
    type: FETCH_DRAFTS_SUCCESSFUL,
    payload: drafts,
  };
}

export function fetchDraftsFailure(error) {
  return {
    type: FETCH_DRAFTS_FAILURE,
    payload: error,
  };
}

export function clearForm() {
  return (dispatch) => {
    dispatch(change('pos', 'ProductNum', ''));
    dispatch(change('pos', 'Quantity', ''));
    dispatch(change('pos', 'CashCharge', ''));
    dispatch(change('pos', 'CheckCharge', ''));
    dispatch(change('pos', 'CreditCharge', ''));
    dispatch(change('pos', 'FinalCharge', ''));
  };
}

// export function createSalesReturn({
//             Promo,
//             Tax,
//             ReStockingFee,
//             Note
//           },{
//             SalesInvoiceCompleted_id,
//             CustomerNum
//           },
//           TotalPrice,
//           Sales_Return_Line,
//           CustomerNumWithoutInvoice,
//           ReturnStatus) {
//             let FinalPrice = (parseFloat(Promo) || 0) + (parseFloat(Tax) || 0) + (parseFloat(ReStockingFee) || 0) + (parseFloat(TotalPrice) || 0)
//             let ReturnDate = new Date;
//             if(CustomerNumWithoutInvoice)
//               CustomerNumWithoutInvoice = CustomerNumWithoutInvoice.value || CustomerNumWithoutInvoice;
//             CustomerNum = CustomerNum || CustomerNumWithoutInvoice;
//             return dispatch => {
// dispatch({ type: REQUEST_CREATING_SALES_RETURN });
// axios.post(SALES_RETURN_URL,
//     {
//         Promo,
//         Tax,
//         ReStockingFee,
//         TotalPrice,
//         FinalPrice,
//         SalesInvoiceCompleted_id,
//         CustomerNum,
//         ReturnDate,
//         Sales_Return_Line,
//         ReturnStatus,
//         Note
//     },
//     {
//         headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
//     }
// )
// .then(response => {
//     dispatch(createSalesReturnSuccess());
//     browserHistory.push('/customerReturn');
// })
// .catch(response => {
//     dispatch(createSalesReturnFailure(response));
// })
//   }
// }

export function createCreditIssue(Deliver_Customer_id, TotalPrice, TaxRate, Tax, CRV, RestockingFee, RestockingFeePercentage, FinalPrice, Note, invoice, PostingDate, Pickup_Warehouse_id, Sales_User_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_RETURN });
    const Sales_Return_Line = [];
    for (let i = 0; i < invoice.rows.length; i++) {
      const newEntry = {};
      newEntry.Product_id = invoice.rows[i].Product_id;
      if (isEKC || isLMH || isBRO) {
        newEntry.SqftPack = invoice.rows[i].SqftPack;
      }
      newEntry.Name = invoice.rows[i].Name;
      newEntry.Description = invoice.rows[i].Description;
      newEntry.ProductType = invoice.rows[i].ProductType;
      newEntry.UnitPrice = parseFloat(invoice.rows[i].UnitPrice);
      newEntry.ReturnQuantity = parseFloat(invoice.rows[i].ReturnQuantity);
      newEntry.ReturnCRV = parseFloat(invoice.rows[i].CRV);
      newEntry.ReturnTotalPrice = parseFloat(invoice.rows[i].ReturnTotalPrice);
      newEntry.ReturnWeight = parseFloat(invoice.rows[i].ReturnWeight);
      newEntry.ReturnWeightsList = invoice.rows[i].Weights;
      newEntry.ReturnReason = invoice.rows[i].ReturnReason;
      newEntry.IsProductReturned = invoice.rows[i].IsProductReturned;
      if(isGGI) {
        newEntry.SmallUnitPrice = invoice.rows[i].SmallUnitPrice
      }
      Sales_Return_Line.push(newEntry);
    }
    TotalPrice = parseFloat(TotalPrice);
    Tax = parseFloat(Tax);
    CRV = parseFloat(CRV);
    RestockingFee = parseFloat(RestockingFee);
    RestockingFeePercentage = parseFloat(RestockingFeePercentage);
    FinalPrice = parseFloat(FinalPrice);
    let dt = isGGI ? {
      Deliver_Customer_id,
      Sales_Return_Line,
      TotalPrice,
      TaxRate,
      Tax,
      CRV,
      RestockingFee,
      RestockingFeePercentage,
      FinalPrice,
      Note,
      PostingDate: convertUtcDate(PostingDate),
      Pickup_Warehouse_id,
      Sales_User_id: Sales_User_id && Sales_User_id.value,
    } : {
      Deliver_Customer_id,
      Sales_Return_Line,
      TotalPrice,
      TaxRate,
      Tax,
      CRV,
      RestockingFee,
      RestockingFeePercentage,
      FinalPrice,
      Note,
      PostingDate: convertUtcDate(PostingDate),
      Pickup_Warehouse_id,
    }
    axios.post(
      SALES_ISSUE_CREDIT_URL,
      dt,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createCreditIssueSuccess());
        browserHistory.push('/inventoryReturn');
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createCreditIssueFailure(err));
      });
  };
}

export const uploadSOWalmartFile = (file) => dispatch => {
  axios({
    method: 'post',
    url: `${ROOT_URL}v1/edi/upload_walmart_shipment/`,
    data: file,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    alert('Upload Success');
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    if(err.data && err.data.message) {
      alert(err.data.message);
    } else {
      alert('Upload Failed');
    }
  })
}
export const sendSOWalmartFile = (ids) => dispatch => {
  axios({
    method: 'post',
    url: `${ROOT_URL}v1/edi/send_856edi/`,
    data:{ ids },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    alert('Send Success');
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    if(err.data && err.data.message) {
      alert(err.data.message);
    } else {
      alert("Send Failed");
    }
  })
}

export function createCreditIssueSuccess() {
  return {
    type: CREATE_SALES_RETURN_SUCCESS,
  };
}

export function createCreditIssueFailure(error) {
  return {
    type: CREATE_SALES_RETURN_FAILURE,
    payload: error,
  };
}

export function createSalesReturn(InvoiceNum, TotalPrice, Tax, CRV, RestockingFee, RestockingFeePercentage, FinalPrice, Note, invoice, SalesInvoice_id, CreditInvoiceNum, PostingDate, Redeliver = false, ReturnedSavings, OverwriteFee, isCheckAble) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_RETURN });
    const SRNum = `${InvoiceNum}R`;
    const Sales_Return_Line = [];
    for (let i = 0; i < invoice.selectedRows.length; i++) {
      const newEntry = {};
      newEntry.Product_id = invoice.selectedRows[i].Product_id;
      if (isEKC || isLMH || isBRO) {
        newEntry.SqftPack = invoice.selectedRows[i].SqftPack;
      }
      newEntry.SalesInvoiceLine_id = invoice.selectedRows[i].SalesInvoiceLine_id;
      newEntry.Name = invoice.selectedRows[i].Name;
      newEntry.Description = invoice.selectedRows[i].Description;
      newEntry.ProductType = invoice.selectedRows[i].ProductType;
      newEntry.UnitPrice = parseFloat(invoice.selectedRows[i].UnitPrice);
      newEntry.ReturnQuantity = parseFloat(invoice.selectedRows[i].ReturnQuantity);
      newEntry.ReturnCRV = parseFloat(invoice.selectedRows[i].ReturnCRV);
      newEntry.ReturnTotalPrice = parseFloat(invoice.selectedRows[i].ReturnTotalPrice);
      newEntry.ReturnReason = invoice.selectedRows[i].ReturnReason;
      newEntry.ReturnWeight = parseFloat(invoice.selectedRows[i].ReturnWeight);
      if(isGGI) {
        newEntry.SmallUnitPrice = invoice.selectedRows[i].SmallUnitPrice;
      }
      if (invoice.selectedRows[i].ProductType === 'Non-Fixed') {
        newEntry.ReturnWeightsList = invoice.selectedRows[i].ReturnWeightsList;
      }
      if (isVAK) {
        if (isCheckAble) {
          newEntry.SerialNum = (invoice.selectedRows[i].serialArrData || []).filter(item => item.isSelected).map(item => item.Num).join(',');
        } else {
          newEntry.SerialNum = invoice.selectedRows[i].SerialNum
        }
      }
      Sales_Return_Line.push(newEntry);
    }
    TotalPrice = parseFloat(TotalPrice);
    ReturnedSavings = parseFloat(ReturnedSavings);
    Tax = parseFloat(Tax);
    CRV = parseFloat(CRV);
    RestockingFee = parseFloat(RestockingFee);
    RestockingFeePercentage = parseFloat(RestockingFeePercentage);
    OverwriteFee = parseFloat(OverwriteFee);
    FinalPrice = parseFloat(FinalPrice);
    axios.post(
      `${SALES_RETURN_URL}?SalesInvoice_id=${SalesInvoice_id}&Redeliver=${Redeliver}`,
      {
        SRNum,
        Sales_Return_Line,
        TotalPrice,
        ReturnedSavings,
        Tax,
        CRV,
        RestockingFee,
        RestockingFeePercentage,
        FinalPrice,
        Note,
        PostingDate: convertUtcDate(PostingDate),
        CreditInvoiceNum: CreditInvoiceNum || '',
        OverwriteFee,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createSalesReturnSuccess());
        browserHistory.push('/inventoryReturn');
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createSalesReturnFailure(err));
      });
  };
}


export function createSalesReturnSuccess() {
  return {
    type: CREATE_SALES_RETURN_SUCCESS,
  };
}

export function createSalesReturnFailure(error) {
  return {
    type: CREATE_SALES_RETURN_FAILURE,
    payload: error,
  };
}

export function editSalesReturn(SRNum, TotalPrice, Tax, CRV, RestockingFee, RestockingFeePercentage, FinalPrice, Note, invoice, SalesReturn_id, CreditInvoiceNum, PostingDate, ReturnedSavings, OverwriteFee, isCheckAble) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_RETURN });
    const Sales_Return_Line = [];
    for (let i = 0; i < invoice.selectedRows.length; i++) {
      const newEntry = {};
      newEntry.Product_id = invoice.selectedRows[i].Product_id;
      if (isEKC || isLMH || isBRO) {
        newEntry.SqftPack = invoice.selectedRows[i].SqftPack;
      }
      newEntry.SalesInvoiceLine_id = invoice.selectedRows[i].SalesInvoiceLine_id;
      newEntry.Name = invoice.selectedRows[i].Name;
      newEntry.Description = invoice.selectedRows[i].Description;
      newEntry.ProductType = invoice.selectedRows[i].ProductType;
      newEntry.UnitPrice = parseFloat(invoice.selectedRows[i].UnitPrice);
      newEntry.ReturnQuantity = parseFloat(invoice.selectedRows[i].ReturnQuantity);
      newEntry.ReturnCRV = parseFloat(invoice.selectedRows[i].ReturnCRV);
      newEntry.ReturnTotalPrice = parseFloat(invoice.selectedRows[i].ReturnTotalPrice);
      newEntry.ReturnReason = invoice.selectedRows[i].ReturnReason;
      newEntry.SalesReturnLine_id = invoice.selectedRows[i].SalesReturnLine_id;
      if (invoice.selectedRows[i].ProductType === 'Non-Fixed') {
        newEntry.ReturnWeight = parseFloat(invoice.selectedRows[i].ReturnWeight);
        newEntry.ReturnWeightsList = invoice.selectedRows[i].ReturnWeightsList;
      }
      if(isGGI) {
        newEntry.SmallUnitPrice = invoice.selectedRows[i].SmallUnitPrice;
      }
      if (isVAK) {
        newEntry.SerialNum = invoice.selectedRows[i].SerialNum
      }
      Sales_Return_Line.push(newEntry);
    }
    TotalPrice = parseFloat(TotalPrice);
    ReturnedSavings = parseFloat(ReturnedSavings);
    Tax = parseFloat(Tax);
    CRV = parseFloat(CRV);
    RestockingFee = parseFloat(RestockingFee);
    let RestockingFRestockingFeePercentageeeP = parseFloat(RestockingFeePercentage);
    OverwriteFee = parseFloat(OverwriteFee);
    FinalPrice = parseFloat(FinalPrice);
    axios.put(
      SALES_RETURN_URL + SalesReturn_id,
      {
        SRNum,
        Sales_Return_Line,
        TotalPrice,
        ReturnedSavings,
        Tax,
        CRV,
        RestockingFee,
        RestockingFeePercentage:RestockingFRestockingFeePercentageeeP,
        FinalPrice,
        Note,
        PostingDate: convertUtcDate(PostingDate),
        CreditInvoiceNum: CreditInvoiceNum || '',
        OverwriteFee,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editSalesReturnSuccess());
        browserHistory.push('/inventoryReturn');
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editSalesReturnFailure(err));
      });
  };
}

export function editSalesReturnSuccess() {
  return {
    type: CREATE_SALES_RETURN_SUCCESS,
  };
}

export function editSalesReturnFailure(error) {
  return {
    type: CREATE_SALES_RETURN_FAILURE,
    payload: error,
  };
}

export function fetchSalesReturnDetail(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_RETURN_DETAIL });
    return axios.get(
      SALES_RETURN_URL + id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesReturnDetailSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesReturnDetailFailure(err));
      });
  };
}

export function fetchSalesReturnDetailSuccess(form) {
  return {
    type: FETCH_SALES_RETURN_DETAIL_SUCCESS,
    payload: form,
  };
}

export function fetchSalesReturnDetailFailure(error) {
  return {
    type: FETCH_SALES_RETURN_DETAIL_FAILURE,
    payload: error,
  };
}

export function fetchInventoryReturns(SalesReturn_id__ReturnDate__gte, SalesReturn_id__ReturnDate__lte, days, search) {
  const dates = toFromDates(days, SalesReturn_id__ReturnDate__gte, SalesReturn_id__ReturnDate__lte);
  return (dispatch, getState) => {
    dispatch({ type: REQUEST_INVENTORY_RETURN });
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    const selectedWarehouse = state.header.selectedWarehouse;
    if (!selectedCompany) return;
    if (search != null && search != '') { search = `&search=${search}`; } else { search = ''; }
    let url = `${SALES_RETURN_URL}?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}&Company_id=${selectedCompany.value}`
    if((isCCW || isGGI) && (selectedWarehouse || {value: ''}).value) {
      url+= `&warehouse_id=${selectedWarehouse.value}`
    }
    if (isVAK) {
      url += search
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryReturnsSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInventoryReturnsFailure(err));
      });
  };
}

export const finalizeSalesReturns = (ids, success, failed) => dispatch => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/sales_return_finalized/${ids}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success();
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      failed();
    })
}

export const fetchSalesReturnPDF = (salesReturnID) => dispatch => {
  const token = `Bearer=${localStorage.getItem('token')}`;
  let url = `${ROOT_URL}v1/sale/printreturn/${salesReturnID}`;
  if(isOLG) {
    let sq = new Date().getTimezoneOffset();
    let time = -sq / 60;
    if(sq > 0 && isDst()) {
      sq+=60;
      let zone = -sq / 60;
      url += `?time_zone=${zone}&time_diff=${time}`;
    } else {
      url += `?time_zone=${(time)}&time_diff=${time}`;
    }
  }
  axios({
    method: 'GET',
    url: url,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    responseType: 'blob',
  })
    .then(res => {
      dispatch({
        type: SALES_RETURN_PDF,
        payload: res.data,
      })
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      alert(JSON.stringify(err.data));
    })
}

export const syncSalesReturnsToQB = (sales_return_ids) => dispatch => {
  dispatch({ type: REQUEST_SYNC_QB_PDF });
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/quickbook/sync_sales_return?sales_return_ids=${sales_return_ids}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      dispatch({ type: FETCH_SYNC_QB_PDF_SUCCESS });
      alert('Success')
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      let message = err.data || err;
      alert(JSON.stringify(message));
      dispatch({ type: FETCH_SYNC_QB_PDF_FAILURE });
    })
}

export function fetchInventoryReturnsSuccess(form) {
  return {
    type: FETCH_INVENTORY_RETURN_SUCCESS,
    payload: form,
  };
}

export function fetchInventoryReturnsFailure(error) {
  return {
    type: FETCH_INVENTORY_RETURN_FAILURE,
    payload: error,
  };
}

export function fetchInventoryReturnsDetails(SalesReturn_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORY_RETURN_DETAILS });
    return axios.get(
      SALES_RETURN_URL + SalesReturn_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryReturnsDetailsSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInventoryReturnsDetailsFailure(err));
      });
  };
}

export function fetchInventoryReturnsDetailsSuccess(form) {
  return {
    type: FETCH_INVENTORY_RETURN_DETAILS_SUCCESS,
    payload: form,
  };
}

export function fetchInventoryReturnsDetailsFailure(error) {
  return {
    type: FETCH_INVENTORY_RETURN_DETAILS_FAILURE,
    payload: error,
  };
}

export function editInventoryReturns(SalesReturnLine) {
  return (dispatch) => {
    dispatch({ type: EDIT_INVENTORY_RETURN });
    return axios.put(
      `${SALES_RETURN_URL}inventory/`,
      {
        SalesReturnLine,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editInventoryReturnsSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editInventoryReturnsFailure(err));
      });
  };
}

export function editInventoryReturnsSuccess(form) {
  return {
    type: EDIT_INVENTORY_RETURN_SUCCESS,
    payload: form,
  };
}

export function editInventoryReturnsFailure(error) {
  return {
    type: EDIT_INVENTORY_RETURN_FAILURE,
    payload: error,
  };
}

export function fetchCustomerPrices(pk) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_PRICES });
    return axios.get(
      INVENTORIES_URL + pk,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerPricesSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerPricesFailure(err));
      });
  };
}

export function fetchCustomerPricesSuccess(prices) {
  return {
    type: FETCH_CUSTOMER_PRICES_SUCCESS,
    payload: prices,
  };
}

export function fetchCustomerPricesFailure(error) {
  return {
    type: FETCH_CUSTOMER_PRICES_FAILURE,
    payload: error,
  };
}

export function fetchCurrencyRatesSuccess(rates) {
  return {
    type: FETCH_CURRENCY_RATES_SUCCESS,
    payload: rates,
  };
}

export function fetchCurrencyRatesFailure(error) {
  return {
    type: FETCH_CURRENCY_RATES_FAILURE,
    payload: error,
  };
}

export function fetchCurrencyRates() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CURRENCY_RATES });
    return axios({
      method: 'get',
      url: CURRENCY_RATES_URL,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(fetchCurrencyRatesSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCurrencyRatesFailure(err));
      });
  };
}

function editMultiCurrenciesSuccess(data) {
  return {
    type: EDIT_MULTI_CURRENCIES_SUCCESS,
    payload: data,
  };
}

function editMultiCurrenciesFailure(error) {
  return {
    type: EDIT_MULTI_CURRENCIES_FAILURE,
    payload: error,
  };
}

export function editMultiCurrencies(currencies) {
  return (dispatch) => {
    dispatch({ type: EDIT_MULTI_CURRENCIES });
    return axios({
      method: 'put',
      url: CURRENCY_RATES_URL,
      data: currencies,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(editMultiCurrenciesSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editMultiCurrenciesFailure(err));
      });
  };
}

export function fetchTaxRatesSuccess(rates) {
  return {
    type: FETCH_TAX_RATES_SUCCESS,
    payload: rates,
  };
}

export function fetchTaxRatesFailure(error) {
  return {
    type: FETCH_TAX_RATES_FAILURE,
    payload: error,
  };
}

export function fetchTaxRates(pk, companyId = '', zip) {
  if (pk === undefined || pk === null) { pk = ''; }
  let companyParam = '';
  if (companyId) {
    companyParam = 'Company_id_id=' + companyId;
  }
  if (isVAK && zip) {
    companyParam += '&zip=' + zip;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_TAX_RATES });
    return axios({
      method: 'get',
      url: TAX_RATES_URL + pk + `?${companyParam}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(fetchTaxRatesSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchTaxRatesFailure(err));
      });
  };
}

function editMultiTaxesSuccess(data) {
  return {
    type: EDIT_MULTI_TAXES_SUCCESS,
    payload: data,
  };
}

function editMultiTaxesFailure(error) {
  return {
    type: EDIT_MULTI_TAXES_FAILURE,
    payload: error,
  };
}

export function editMultiTaxes(taxes) {
  return (dispatch) => {
    dispatch({ type: EDIT_MULTI_TAXES });
    return axios({
      method: 'post',
      url: TAX_RATES_URL,
      data: taxes,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(editMultiTaxesSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editMultiTaxesFailure(err));
      });
  };
}

function deleteTaxSuccess(data) {
  return {
    type: DELETE_TAX_SUCCESS,
    payload: data,
  };
}

function deleteTaxFailure(error) {
  return {
    type: DELETE_TAX_FAILURE,
    payload: error,
  };
}

export function deleteTax(taxAreaId) {
  return (dispatch) => {
    dispatch({ type: DELETE_TAX });
    return axios({
      method: 'delete',
      url: TAX_RATES_URL + taxAreaId,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(deleteTaxSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(deleteTaxFailure(err));
      });
  };
}

export function fetchOverallSalesPerformance(type) {
  const start_date = moment().toISOString();
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;    
    dispatch({ type: REQUEST_OVERALL_SALES_PERFORMANCE });
    let url = OVERALL_SALES_PERFORMANCE_URL
    if (isGGI && selectedCompany) {
      url += `?company_id=${selectedCompany.value}`
    }
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        type,
        start_date,
      },
    }).then((response) => {
      dispatch(fetchOverallSalesPerformanceSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchOverallSalesPerformanceFailure(err));
    });
  };
}

export function fetchOverallSalesPerformanceSuccess(data) {
  return {
    type: FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS,
    payload: data,
  };
}

export function fetchOverallSalesPerformanceFailure(error) {
  return {
    type: FETCH_OVERALL_SALES_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function fetchPosReport(type, days, fromDate, toDate, division, num, salesID) {
  if (salesID == null) { salesID = ''; } else {
    salesID = `&Order_id__Sales_user=${salesID}`;
  }
  const dates = toFromDates(days, fromDate, toDate);

  if (days == null || days == -1 || days == 'none') days = '';
  else days = `/${days}`;

  return (dispatch) => {
    dispatch({ type: REQUEST_POS_REPORT });
    return axios.get(
      `${POS_REPORT_URL + type + days}/` +
      `?Order_id__Date__gte=${dates.fromDate}&Order_id__Date__lte=${dates.toDate}${division}${num}${salesID}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPosReportSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosReportFailure(err));
      });
  };
}

export function fetchPosReportSuccess(results) {
  return {
    type: FETCH_POS_REPORT_SUCCESS,
    payload: results,
  };
}

export function fetchPosReportFailure(error) {
  return {
    type: FETCH_POS_REPORT_FAILURE,
    payload: error,
  };
}


export function fetchSalesInventoryInfo(customer_id, type, value, Company_id) {
  if (value == null) value = ' ';
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_INVENTORY_INFO });
    return axios.get(
      `${SALES_INVENTORY_INFO_URL + customer_id}/?${type}=${value}&Company_id=${Company_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesInventoryInfoSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesInventoryInfoFailure(err));
      });
  };
}

export function fetchSalesInventoryInfoSuccess(info) {
  return {
    type: FETCH_SALES_INVENTORY_INFO_SUCCESS,
    payload: info,
  };
}

export function fetchSalesInventoryInfoFailure(error) {
  return {
    type: FETCH_SALES_INVENTORY_INFO_FAILURE,
    payload: error,
  };
}

export function fetchSalesCustomerDetail(pk, SalesOrder_id, isShippingCustomer, cb) {
  let url = SALES_CUSTOMER_URL + ((SalesOrder_id) ? (`${SalesOrder_id}/order`) : pk);
  return (dispatch) => {
    if (isShippingCustomer) {
      dispatch({ type: REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL });
    } else {
      dispatch({ type: REQUEST_SALES_CUSTOMER_DETAIL });
    }
    if (isOLG) {
      let currentDate = moment().format('YYYY-MM-DD');
      const { toDate } = getFromToDates(currentDate);
      url+= `?current_time=${toDate}`;
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        if (isShippingCustomer) {
          cb && cb(response);
          dispatch(fetchShippingCustomerDetailSuccess(response));
        } else {
          dispatch(fetchSalesCustomerDetailSuccess(response));
        }
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesCustomerDetailFailure(err));
      });
  };
}

export function fetchShippingCustomerDetailSuccess(details) {
  return { type: FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS, payload: details };
}

export function fetchSalesCustomerDetailSuccess(details) {
  return { type: FETCH_SALES_CUSTOMER_DETAIL_SUCCESS, payload: details };
}

export function fetchSalesCustomerDetailFailure(error) {
  return { type: FETCH_SALES_CUSTOMER_DETAIL_FAILURE, payload: error };
}

export function fetchAllShipping() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SHIPPING_DETAIL });
    return axios.get(
      SHIPPING_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchAllShippingDetailSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchAllShippingDetailFailure(err));
      });
  };
}

export function fetchAllShippingDetailSuccess(details) {
  return {
    type: FETCH_SHIPPING_DETAIL_SUCCESS,
    payload: details,
  };
}

export function fetchAllShippingDetailFailure(error) {
  return {
    type: FETCH_SHIPPING_DETAIL_FAILURE,
    payload: error,
  };
}

export function fetchPurchasesVendorDetail(Vendor_id) {
  const url = `${PURCHASES_VENDOR_URL + Vendor_id}/`;
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASES_VENDOR_DETAIL });
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasesVendorDetailSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPurchasesVendorDetailFailure(err));
      });
  };
}

export function fetchPurchasesVendorDetailSuccess(details) {
  return {
    type: FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS,
    payload: details,
  };
}

export function fetchPurchasesVendorDetailFailure(error) {
  return {
    type: FETCH_PURCHASES_VENDOR_DETAIL_FAILURE,
    payload: error,
  };
}

export function clearSalesCustomerDetails() {
  return {
    type: CLEAR_SALES_CUSTOMER_DETAILS,
  };
}

export function fetchItemSalesHistory(Customer_id, Product_id, isLowest=false) {
  return (dispatch) => {
    dispatch({ type: REQUEST_ITEM_SALES_HISTORY });
    let lowest = '';
    if (isLowest === true) {
      lowest = '?lowest_price=True';
    }
    return axios.get(
      `${ITEM_HISTORY_URL + Customer_id}/${Product_id}${lowest}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchItemSalesHistorySuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchItemSalesHistoryFailure(err));
      });
  };
}
export function fetchItemPurchaseHistory(warehouse_id, product_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_ITEM_PURCHASE_HISTORY });
    let params = {};
    if (warehouse_id) {
      params.warehouse_id = warehouse_id;
    }
    if (product_id) {
      params.product_id = product_id;
    }
    return axios.get(
      ITEM_PURCHASE_HISTORY_URL,
      {
        params,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchItemPurchaseHistorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchItemPurchaseHistoryFailure(err));
      });
  };
}

export function fetchItemSalesHistorySuccess(hist) {
  return {
    type: FETCH_ITEM_SALES_HISTORY_SUCCESS,
    payload: hist,
  };
}

export function fetchItemSalesHistoryFailure(error) {
  return {
    type: FETCH_ITEM_SALES_HISTORY_FAILURE,
    payload: error,
  };
}

export function fetchItemPurchaseHistorySuccess(hist) {
  return {
    type: FETCH_ITEM_PURCHASE_HISTORY_SUCCESS,
    payload: hist,
  };
}

export function fetchItemPurchaseHistoryFailure(error) {
  return {
    type: FETCH_ITEM_PURCHASE_HISTORY_FAILURE,
    payload: error,
  };
}

export function fetchCustomerFrequent(Customer_id, Company_id = '', Warehouse_id = '') {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_FREQUENT });
    let params = {};
    if (Company_id) {
      params.Company_id = Company_id;
    }
    if (Warehouse_id) {
      params.Warehouse_id = Warehouse_id;
    }
    return axios.get(
      FREQUENT_ITEMS_URL + Customer_id,
      {
        params,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerFrequentSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerFrequentFailure(err));
      });
  };
}

export function fetchInboundProducts() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_FREQUENT });
    return axios.get(
      INBOUND_PRODUCTS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerFrequentSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerFrequentFailure(err));
      });
  };
}

export function fetchCustomerFrequentSuccess(items) {
  return {
    type: FETCH_CUSTOMER_FREQUENT_SUCCESS,
    payload: items,
  };
}

export function fetchCustomerFrequentFailure(error) {
  return {
    type: FETCH_CUSTOMER_FREQUENT_FAILURE,
    payload: error,
  };
}

export function initializeForm(data, fields, Form) {
  return (dispatch) => {
    dispatch(initialize(Form, data, fields));
  };
}

export function setSalesOrdersFilter(data) {
  return {
    type: SET_SALES_ORDERS_FILTER,
    payload: data,
  };
}

export function setSalesOrdersPaginationFilter(data) {
  return {
    type: SET_SALES_ORDERS_PAGINATION_FILTER,
    currentPage: data.currentPage,
  };
}

export function fetchSalesPerformance(salesType, days, fromDate, toDate, type, productNum, group, category, aggregate) {
  const dates = toFromDates(days, fromDate, toDate);
  if (salesType == 'salesorder') {
    fromDate = `SalesInvoice_id__DispatchDate__gte=${dates.fromDate}`;
    toDate = `SalesInvoice_id__DispatchDate__lte=${dates.toDate}`;
  } else if (salesType == 'posorder') {
    fromDate = `Order_id__Date__gte=${dates.fromDate}`;
    toDate = `Order_id__Date__lte=${dates.toDate}`;
  } else if (salesType == 'all') {
    fromDate = `date__gte=${dates.fromDate}`;
    toDate = `date__lte=${dates.toDate}`;
  }
  if (productNum) {
    productNum = `&Product_id__ProductNum=${productNum}`;
    group = '';
    category = '';
    aggregate = '';
  } else {
    productNum = '';
    if (group) {
      group = `&Product_id__ProductGroup_id=${group}`;
    } else {
      group = '';
    }
    if (category) {
      category = `&Product_id__ProductCategory1_id=${category}`;
    } else {
      category = '';
    }
    if (aggregate) {
      aggregate = `&Aggregate=${aggregate}`;
    } else {
      aggregate = '';
    }
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_PERFORMANCE });
    return axios.get(
      `${SALES_PERFORMANCE_URL + type}/${salesType}/?${fromDate}&${toDate}${productNum}${group}${category}${aggregate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesPerformanceSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesPerformanceFailure(err));
      });
  };
}

export function fetchSalesPerformanceSuccess(data) {
  return {
    type: REQUEST_SALES_PERFORMANCE_SUCCESS,
    payload: data,
  };
}

export function fetchSalesPerformanceFailure(error) {
  return {
    type: REQUEST_SALES_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function fetchSalesOrdersByFilter(postingDateGT, postingDateLT, days, status, user, routeName, productNum, route) {
  const url = (route == 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  if (status == 'all') {
    status = '';
  } else {
    status = `&SaleStatus=${status}`;
  }
  if (user) {
    user = `&Sales_User_id=${user}`;
  } else {
    user = '';
  }

  if (routeName) {
    routeName = `&RouteName=${routeName}`;
  } else {
    routeName = '';
  }

  let belongWarehouse = ``;
  if ( isAFM ){
    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
      belongWarehouse = ``;
    } else {
      belongWarehouse = `&BelongWarehouse=${localStorage.getItem('warehouseLocation')}`;
    }
  }

  if (productNum) {
    productNum = `&ProductNum=${productNum}`;
  } else {
    productNum = '';
  }
  return (dispatch) => {
    dispatch(requestSalesOrders());
    return axios.get(
      `${url}search/` + `?OrderDate__gte=${dates.fromDate
      }&OrderDate__lte=${dates.toDate}${status}${user}${productNum}${belongWarehouse}${routeName}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrdersSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrdersFailure(err));
      });
  };
}

export function fetchSalesDashboardDetail() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_DASHBOARD_DETAIL });
    return axios.get(
      `${DASHBOARD_URL}salesdashboard/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesDashboardDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesDashboardDetailFailure(err));
      });
  };
}

export function requestSalesDashboardDetail() {
  return {
    type: REQUEST_SALES_DASHBOARD_DETAIL,
  };
}

export function fetchSalesDashboardDetailSuccess(dashboardSalesDetail) {
  return {
    type: FETCH_SALES_DASHBOARD_DETAIL_SUCCESS,
    payload: dashboardSalesDetail,
  };
}

export function fetchSalesDashboardDetailFailure(error) {
  return {
    type: FETCH_SALES_DASHBOARD_DETAIL_FAILURE,
    payload: error,
  };
}

export function loadsPost(pk) {
  return dispatch => axios.get(
    `${SALES_LOADSPOST_URL + pk}/`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  );
}

export function fetchSalesLevels() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_LEVELS });
    return axios.get(
      SALES_LEVELS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesLevelsSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesLevelsFailure(err));
      });
  };
}

export function fetchSalesLevelsSuccess(levels) {
  return {
    type: FETCH_SALES_LEVELS_SUCCESS,
    payload: levels,
  };
}

export function fetchSalesLevelsFailure(error) {
  return {
    type: FETCH_SALES_LEVELS_FAILURE,
    payload: error,
  };
}


/* Payment refund for MSO */
/* id: MSO id */
export function requestSORefund(id, props) {
  return (dispatch) => {
    dispatch(requestingSORefund());
    const token = localStorage.getItem('token');
    const data = {
      Amount: props.refundAmount * 100,
      Reason: props.refundReason,
    };
    return axios({
      method: 'post',
      url: `${SALES_ORDERS_REFUND}${id}/refund`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    })
      .then((response) => {
        dispatch(requestSORefundSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(requestSORefundFailure(err));
      });
  };
}

export function requestingSORefund() {
  return {
    type: REQUEST_REFUND,
  };
}

export function requestSORefundSuccess(data) {
  return {
    type: REQUEST_REFUND_SUCCESS,
    payload: data,
  };
}

export function requestSORefundFailure(error) {
  return {
    type: REQUEST_REFUND_FAILURE,
    payload: error,
  };
}

export function voidReturn(SalesReturn_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_RETURN_VOID });
    return axios.post(
      `${SALES_RETURN_URL + SalesReturn_id}/void`,
      {
        SalesReturn_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchReturnsSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchReturnsFailure(err));
      });
  };
}

export function completeReturn(SalesReturn_id, InvoiceDetails) {
  const Sales_Return_Line = [];
  const newEntry = {};
  for (let i = 0; i < InvoiceDetails.length; i++) {
    newEntry.SalesReturnLine_id = InvoiceDetails[i].SalesReturnLine_id;
    newEntry.RestockQuantity = InvoiceDetails[i].RestockQuantity;
    newEntry.RestockWeight = (InvoiceDetails[i].RestockWeight) ? InvoiceDetails[i].RestockWeight : 0;
    // Sales_Return_Line.push(newEntry);
    const lineData = {
      SalesReturnLine_id: InvoiceDetails[i].SalesReturnLine_id,
      RestockQuantity: InvoiceDetails[i].RestockQuantity,
      RestockWeight: (InvoiceDetails[i].RestockWeight) ? InvoiceDetails[i].RestockWeight : 0,
      location: InvoiceDetails[i].location,
      expire_datetime: InvoiceDetails[i].expire_datetime,
    }
    if (isVAK) {
      delete lineData.location;
      lineData.SerialNum = InvoiceDetails[i].SerialNum;
    }
    Sales_Return_Line.push(lineData);
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_RETURN_COMPLETE });
    return axios.post(
      `${SALES_RETURN_URL + SalesReturn_id}/complete`,
      {
        Sales_Return_Line,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchReturnsSuccess(response));
        browserHistory.push('/inventoryReturn');
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchReturnsFailure(err));
        console.log('ERROR IN response');
      });
  };
}

export function fetchReturnsSuccess(data) {
  return {
    type: FETCH_RETURN_SUCCESS,
    payload: data,
  };
}
export function fetchReturnsFailure(error) {
  return {
    type: FETCH_RETURN_FAILURE,
    payload: error,
  };
}

export const fetchProductPromotion = (product_id, Company_id, customer, success = () => {}) => dispatch => {
  dispatch({
    type: 'salesOrderForm/productpromotionfetching',
  })
  let url = `${PROMOTIONS_URL}?Product_id=${product_id}&Company_id=${Company_id}`;
  if ((isLMH || isBRO || isSDR || isCRW || isSC) && customer) {
    url = `${PROMOTIONS_URL}?Product_id=${product_id}&Company_id=${Company_id}&Customer_id=${customer}`;
  }
  axios.get(
    url,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      dispatch({
        type: 'salesOrderForm/productpromotion',
        payload: response.data.promotions,
      })
      success()
      // dispatch(fetchSalesOrderProductByIDSuccesful(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      // if (err.status === 500 || err.status === 404) {
      //   err.data = DEFAULT_ERROR;
      // }
      // dispatch(fetchSalesOrderProductByIDFailure(err));
    });
}

export const resetReduxForm = (form) => (dispatch) => {
  dispatch(reset(form))
}

export function fetchSalesOrderProductByID(id, customer_id, company_id, warehouse_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_ID });
    let url = `${SALES_ORDER_PRODUCT_BY_ID_URL}${customer_id}/?Product_id=${id}&Company_id=${company_id}&warehouse_id=${warehouse_id}`;
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderProductByIDSuccesful(response));
        dispatch({
          type: FETCH_PRODUCT_INFO_SUCCESS,
          payload: response,
        })
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderProductByIDFailure(err));
      });
  };
}

export function fetchSalesOrderProductByIDSuccess(id, customer_id, company_id, warehouse_id, success) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_ID });
    let url = `${SALES_ORDER_PRODUCT_BY_ID_URL}${customer_id}/?Product_id=${id}&Company_id=${company_id}&warehouse_id=${warehouse_id}`;
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        success(response)
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderProductByIDFailure(err));
      });
  };
}

export const fetchTruckCompanies = (company_id) => dispatch => {
  const url = `${ROOT_URL}/v1/sale/truck_company/?company_id=${company_id} `
  axios.get(
    url,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      dispatch({
        type: "TRUCK_COMPANY_SHIPPING",
        payload: response.data.Shipping
      })
      // dispatch(fetchSalesOrderProductByIDSuccesful(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      // dispatch(fetchSalesOrderProductByIDFailure(err));
    });
}

export function fetchProductDetail(id, customer_id, company_id, warehouse_id, success) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_ID });
    return axios.get(
      `${SALES_ORDER_PRODUCT_BY_ID_URL}${customer_id}/?Product_id=${id}&Company_id=${company_id}&warehouse_id=${warehouse_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        success(response.data);
        // dispatch(fetchSalesOrderProductByIDSuccesful(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        // dispatch(fetchSalesOrderProductByIDFailure(err));
      });
  };
}

export const fetchBachesByID = (Product_id, Company_id, Pickup_Warehouse_id, cb = () => {}) => dispatch => {
  dispatch({
    type: REQUEST_PRODUCT_BATCHES,
  })
  let url = `${SALES_ORDER_FORM_BACHES}batch?product=${Product_id}&belong_warehouse=${Pickup_Warehouse_id}&company=${Company_id}&is_sales_order=true`;
  return axios.get(
    url,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      dispatch({
        type: SALES_ORDER_FORM_BATCHES,
        payload: response.data,
      });
      cb && cb();
      // dispatch(fetchSalesOrderProductByIDSuccesful(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      // if (err.status === 500 || err.status === 404) {
      //   err.data = DEFAULT_ERROR;
      // }
      // dispatch(fetchSalesOrderProductByIDFailure(err));
    });
}

export const clearSalesOrderFormBatches = () => dispatch => {
  dispatch({
    type: SALES_ORDER_FORM_BATCHES,
    payload: { batches: [] },
  })
}

export function fetchSalesOrderProductByIDSuccesful(product) {
  return {
    type: FETCH_PRODUCT_BY_ID_SUCCESS,
    payload: product,
  };
}

export function fetchSalesOrderProductByIDFailure(error) {
  return {
    type: FETCH_PRODUCT_BY_ID_FAILURE,
    payload: error,
  };
}

export function initializeSalesOrderForm(type, Form) {
  return (dispatch) => {
    dispatch(change(Form, 'searchType', type));
    dispatch(change(Form, 'Quantity', 1));
  };
}

export function printSalesOrderSI(salesInvoiceID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_SI_PDF });
    return axios.get(
      SO_PRINT_SALES_INVOICE_URL + salesInvoiceID,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch({
          type: FETCH_SO_SI_PDF_SUCCESS,
          payload: response,
        });
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrder(salesOrder_id, status, backOrder) {
  let url = SALES_ORDER_PRINT_URL + salesOrder_id;
  if(status === 'Backlog' || (isSV && backOrder)) {
    url += '?backlog=true';
  }
  if (isVAK) {
    const languageBoolean = I18n._locale === "en" ? "True" : "False";
    url += `?IsEnglish=${languageBoolean}`
  }
  let sq = new Date().getTimezoneOffset();
  if(isGGI) {
    if(url.indexOf('?') != -1) {
      url += `&time_zone=${(-sq / 60)}`;
    } else {
      url += `?time_zone=${(-sq / 60)}`;
    }
  }
  if(isOLG) {
    let time = -sq / 60;
    if(sq > 0 && isDst()) {
      sq+=60;
      let zone = -sq / 60;
      url += `?time_zone=${zone}&time_diff=${time}`;
    } else {
      url += `?time_zone=${(time)}&time_diff=${time}`;
    }
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrderLabel(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      SALES_ORDER_LABEL_PRINT_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrderLabelBOL(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      WIZ_PRINT_BOL + salesOrder_id + '?mode=pdf',
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrderLabelDSQ(salesOrderLine_ids) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      SALES_ORDER_LABEL_PRINT_URL + salesOrderLine_ids,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function jmlPrintLabel(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      PRINT_JML_LABEL_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrderLabelBatch(salesOrder_id, labedIds=[], isUnfreeze = false) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    let data = {salesOrder_id};
    let url = `${SALES_ORDER_LABEL_PRINT_URL_BATCH}`;
    if(isVAK) {
      if(labedIds.length > 0) {
        data.label_id = labedIds;
      }
      if(isUnfreeze) {
        url += '?no_limitation=true'
      }
    }
    return axios.post(
      url,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
        if (err.data.type === 'application/json') {
          const reader = new FileReader();
          reader.readAsText(err.data);
          reader.onload = e => {
            alert(JSON.stringify(reader.result));
          }
        }
      });
  };
}

export function printPackingSalesOrder(salesOrder_id, labelIds=[]) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    let data = {salesOrder_id};
    if(isVAK && labelIds.length > 0) {
      data.label_id = labelIds;
    }
    return axios.get(
      `${PACKING_LIST_URL}${salesOrder_id}?label_id=${labelIds}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
        if (err.data.type === 'application/json') {
          const reader = new FileReader();
          reader.readAsText(err.data);
          reader.onload = e => {
            alert(JSON.stringify(reader.result));
          }
        }
      });
  };
}

export function fetchSalesOrderPDFFetch() {
  return {
    type: REQUEST_SO_PDF,
  };
}

export function fetchSalesOrderPDFSuccess(FileData) {
  return {
    type: FETCH_SO_PDF_SUCCESS,
    payload: FileData,
  };
}

// export function removeSalesOrderPDF() {
//   return {
//     type: REMOVE_SHIPPING_PDF
//   }
// }

export function printShippingList(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SHIPPING_LIST_PDF });
    let url = SHIPPING_LIST_URL + salesOrder_id;
    let sq = new Date().getTimezoneOffset();
    if(isGGI) {
      url += `?time_zone=${(-sq / 60)}`;
    }
    if(isOLG) {
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        url += `?time_zone=${zone}&time_diff=${time}`;
      } else {
        url += `?time_zone=${(time)}&time_diff=${time}`;
      }
    }
    if (isVAK) {
      const languageBoolean = I18n._locale === "en" ? "True" : "False";
      url += `?IsEnglish=${languageBoolean}`
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchShippingListPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}
export function createPickingList(salesOrderIds, success, failed) {
  return (dispatch) => {
    let url = CREATE_PICKING_LIST_URL;
    let data = {saleorders: salesOrderIds}
    return axios.post(
      url,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        success(response.data.PKNum)
      }, (err) => {
        failed();
        alert(err.data.message || err)
      });
  };
}

export function fetchShippingListPDFSuccess(FileData) {
  return {
    type: FETCH_SHIPPING_LIST_SUCCESS,
    payload: FileData,
  };
}

export function printPickingList(salesOrder_id, location, isLca = false) {
  if (salesOrder_id) {
    return (dispatch) => {
      dispatch({ type: REQUEST_PICKING_LIST_PDF });
      let sort = '';
      if (isSV && location) {
        sort = '?sort=location'
      }
      if(isSV && isLca) {
        sort = '?isLocation=true'
      }
      let url =  PICKING_LIST_URL + salesOrder_id + sort
      let sq = new Date().getTimezoneOffset();
      if(isGGI) {
        url += `?time_zone=${(-sq / 60)}`;
      }
      if(isOLG) {
        let time = -sq / 60;
        if(sq > 0 && isDst()) {
          sq+=60;
          let zone = -sq / 60;
          url += `?time_zone=${zone}&time_diff=${time}`;
        } else {
          url += `?time_zone=${(time)}&time_diff=${time}`;
        }
      }
      if (isVAK) {
        const languageBoolean = I18n._locale === "en" ? "True" : "False";
        url += `?IsEnglish=${languageBoolean}`
      }
      return axios.get(
        url,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchPickingListPDFSuccess(response));
        }, (err) => {
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
            return
          }
          console.log('ERROR IN response', err);
        });
    };
  }
}

export function printPickingListAFG(salesOrder_id, users, sort) {
  if (users === '0' || !users) {
    users = 1;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_PICKING_LIST_PDF });
    return axios.get(
      PICKING_LIST_URL + salesOrder_id + '?assign=' + users + '&orderBy=' + sort,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPickingListPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function fetchPickingListPDFSuccess(FileData) {
  return {
    type: FETCH_PICKING_LIST_SUCCESS,
    payload: FileData,
  };
}

export function printPackingList(salesOrder_id, location) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PACKING_LIST_PDF });
    let sort = '';
    if (isSV && location) {
      sort = '?sort=location'
    }
    let url = PACKING_LIST_URL + salesOrder_id + sort;
    let sq = new Date().getTimezoneOffset();
    if(isGGI) {
      url += `?time_zone=${(-sq / 60)}`;
    }
    if(isOLG) {
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        url += `?time_zone=${zone}&time_diff=${time}`;
      } else {
        url += `?time_zone=${(time)}&time_diff=${time}`;
      }
    }
    if (isVAK) {
      const languageBoolean = I18n._locale === "en" ? "True" : "False";
      let sq = new Date().getTimezoneOffset();
      url += `?IsEnglish=${languageBoolean}&time_zone=${(-sq / 60)}`
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPackingListPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if(isVAK && err.status == 400 && err.data) {
          err.data.arrayBuffer().then(buffer => {
            // 将ArrayBuffer转换为字符串
            const content = new TextDecoder().decode(buffer);
            alert(content);
          });
        }
        console.log('ERROR IN response', err);
      });
  };
}

export function fetchPackingListPDFSuccess(FileData) {
  return {
    type: FETCH_PACKING_LIST_SUCCESS,
    payload: FileData,
  };
}


function fetchMSORefundPDFSuccess(FileData) {
  return {
    type: REQUEST_REFUND_PDF_SUCCESS,
    payload: FileData,
  };
}

export function printMSORefundPDF(salesOrderID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_REFUND_PDF });
    const token = localStorage.getItem('token');
    return axios({
      method: 'get',
      url: `${REFUND_SUMMARY_URL}${salesOrderID}`,
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchMSORefundPDFSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      console.log('ERROR IN response', err);
    });
  };
}

export function fetchSalesTotalsSuccess(totals) {
  return {
    type: FETCH_SALES_TOTALS_SUCCESS,
    payload: totals,
  };
}

export function fetchSalesTotalsFailure(error) {
  return {
    type: FETCH_SALES_TOTALS_FAILURE,
    payload: error,
  };
}

export function fetchSalesTotals(type) {
  const start_date = moment().toISOString();
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    dispatch({ type: REQUEST_SALES_TOTALS });
    let url = OVERALL_SALES_PERFORMANCE_URL
    if (isGGI && selectedCompany) {
      url += `?company_id=${selectedCompany.value}`
    }
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        type,
        start_date,
      },
    }).then((response) => {
      dispatch(fetchSalesTotalsSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchSalesTotalsFailure(err));
    });
  };
}

export function orderToQuote(salesId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_ORDER_TO_QUOTE });
    return axios({
      method: 'PUT',
      url: `${QUOTE_TO_ORDER_URL}so_to_sq/` + salesId,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
    .then(response => {
      dispatch(orderToQuoteSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      dispatch(orderToQuoteFailure(err));
    });
  };
}

export function orderToQuoteSuccess(response) {
  return {
    type: SALES_ORDER_TO_QUOTE_SUCCESS
  };
}

export function orderToQuoteFailure(err) {
  return {
    type: SALES_ORDER_TO_QUOTE_FAILURE,
    payload: err,
  };
}

export function quoteToOrder(salesId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_QUOTE_TO_OPEN });
    return axios({
      method: 'PUT',
      url: `${QUOTE_TO_ORDER_URL}sq_to_so/` + salesId,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
    .then(response => {
      dispatch(quoteToOrderSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      dispatch(quoteToOrderFailure(err));
    });
  };
}

export function quoteToOrderSuccess(response) {
  return {
    type: REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS
  };
}

export function quoteToOrderFailure(err) {
  return {
    type: REQUEST_SALES_QUOTE_TO_ORDER_FAILURE,
    payload: err,
  };
}

export function emailSO(salesOrder_id, subject, content, email) {
  let data = {subject, content};
  if (isEKC || isLMH || isBRO || isSDR || isCRW || isSC) {
    data = {subject, content, email};
  }
  return (dispatch) => {
    axios.post(
      `${ROOT_URL}v1/sale/emailorder/${salesOrder_id}`,
      // { subject, content },
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
      .then((response) => {
        alert(JSON.stringify(response.data));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        alert(JSON.stringify(err.data));
      });
    };
}

export function emailSR(salesReturn_id, subject, content) {
  let data = {subject, content};
  return (dispatch) => {
    axios.post(
      `${ROOT_URL}v1/sale/emailreturn/${salesReturn_id}`,
      // { subject, content },
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
      .then((response) => {
        alert(JSON.stringify(response.data));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        alert(JSON.stringify(err.data));
      });
  };
}

export function createMobileTask(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: CREATE_MOBILE_TASK });
    axios.post(
      `${MOBILE_SALES_ORDERS_URL}create_onfleet_task/${salesOrder_id}`, {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
      .then((response) => {
        alert(JSON.stringify(response.data));
        dispatch(createMobileTaskSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        alert(JSON.stringify(err.data));
        dispatch(createMobileTaskFailure(err));
      });
    };
}

export function createMobileTaskSuccess(response) {
  return {
    type: CREATE_MOBILE_TASK_SUCCESS,
  };
}

export function createMobileTaskFailure(err) {
  return {
    type: CREATE_MOBILE_TASK_FAILURE,
    payload: err,
  };
}

// export function requestSetShippingWeight() {
//   return {
//     type: REQUEST_SET_SHIPPING_WEIGHT,
//   };
// }

export function updateShippingWeightSuccess(data) {
  return {
    type: UPDATE_SHIPPING_WEIGHT_SUCCESS,
    // payload: data,
  };
}

export function updateShippingWeightFailure(error) {
  return {
    type: UPDATE_SHIPPING_WEIGHT_FAILURE,
    payload: error,
  };
}

export function updateShippingWeight(salesOrder_id, finalShippingWeight) {
  let output = {
    finalShippingWeight: Number(finalShippingWeight)
  }
  const url = `${PATCH_SALES_ORDER_WEIGHT_URL}${salesOrder_id}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_SET_SHIPPING_WEIGHT });
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        // alert(JSON.stringify(response.data));
        // alert(JSON.stringify('Shipping Weight Patched Successfully'));
        dispatch(updateShippingWeightSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
          alert(JSON.stringify(err.data));
        }
        dispatch(updateShippingWeightFailure(err));
      });
  };
}

export function updateShippingWeightSplit(salesOrder_id, splitWeightArray, isUnfreeze = false) {
  let output = [];
  splitWeightArray.map(r => {
    if (!isFinite(r.Package_Weight)) {
      alert("\"" + r.Package_Weight + "\" is not a number and has been omitted!");
    }
    if (isVAK && !r.Dimensions) {
      alert("Please choose a package size!")
    }
    if (isVAK && !r.Product_Details) {
      alert("Package cannot be empty!")
    }
    let valid = r.Package_Weight && isFinite(r.Package_Weight)
    if (isVAK) {
      valid = r.Package_Weight && isFinite(r.Package_Weight) && r.Dimensions && r.Product_Details && r.carrier
    }
    if (valid) {
      let vakParams = {Dimensions: r.Dimensions, Product_Details: r.Product_Details, carrier: r.carrier, id: r.id, shipment_id: r.shipmentId,signature: r.signature}
      if(isVAK) {
        if(r.insurance) {
          vakParams.insurance = r.insurance;
        }
        if(r.insure_amount) {
          vakParams.insure_amount = r.insure_amount+'';
        }
      }
      output.push({ Package_Weight: Number(r.Package_Weight), Package_Note: r.Package_Note ? r.Package_Note : "", Tracking_Number: r.Tracking_Number ? r.Tracking_Number : "", recreate: r.recreate, 
      ...(isVAK ? vakParams : {}) });
    }
  });
  if (output.length === 0 && !isVAK) {
    alert("Must have at least one valid pack.");
    return;
  }
  let url = `${PATCH_SALES_ORDER_WEIGHT_MULTI_URL}${salesOrder_id}`;
  if (isVAK) {
    url = `${PATCH_SALES_ORDER_WEIGHT_MULTI_VAK_URL}${salesOrder_id}`;
    if(isUnfreeze) {
      url += '?no_limitation=true'
    }
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_SET_SHIPPING_WEIGHT_SPLIT });
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        // alert(JSON.stringify(response.data));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if(isVAK) {
          alert(err.data);
        }
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
          alert(JSON.stringify(err.data));
        }
      });
  };
}

export function fetchShippingWeightTracking(salesOrder_id) {
  const url = `${FETCH_SALES_ORDER_WEIGHT_TRACKING}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchCarrierInfo(salesOrder_id) {
  const url = `${CARRIER_INFO_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function postCarrierInfo(salesOrder_id, output) {
  const url = `${CARRIER_INFO_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchJmlTracking(salesOrder_id) {
  const url = `${FETCH_JML_TRACKING_NUMBER_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function updateEmployeeNote(salesOrder_id, employeeNoteText) {
  let output = {
    EmployeeNote: employeeNoteText
  }
  const url = `${PATCH_SALES_EMPLOYEE_NOTE_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function updateVoidNote(salesOrder_id, voidString) {
  let output = {
    VoidNote: voidString
  }
  const url = `${PATCH_SALES_VOID_NOTE_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function reshipOrder(salesOrder_id) {
  const url = `${SALES_ORDER_RESHIP_URL}${salesOrder_id}/`;
  return (dispatch) => {
    return axios({
      method: 'put',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {
      // alert(JSON.stringify(response.data));
      alert("Order has been reshipped!");
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.status === 500 || err.status === 404) {
        // err.data = DEFAULT_ERROR;
      }
      alert("Reshipping failed: " + err);
    });
  };
}

export function setQuoteOrder(salesOrder_id, customer_id, warehouse_id, shipping_id) {
  let url = `${SET_QUOTE_URL}${salesOrder_id}/${customer_id}`;
  if (!isABBLE && shipping_id) {
    url += `/${shipping_id}`;
  }
  if ((isABBLE || isKM) && warehouse_id) {
    url += `?warehouse_id=${warehouse_id}`;
  }
  if (isSKH) {
    url = `${QUOTE_TO_ORDER_URL}sq_to_so/${salesOrder_id}`;
  }
  return (dispatch) => {
    return axios({
      method: 'put',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {
      // alert(JSON.stringify(response.data));
      // alert("Quotes set to Orders!");
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.status === 500 || err.status === 404) {
        // err.data = DEFAULT_ERROR;
      }
      alert("Quote to order failed: " + err.data);
    });
  };
}

export function setQuoteOrderForEsc(salesOrder_id, customer_id, shipping_id) {
  let url = `${SET_QUOTE_ESC_URL}${salesOrder_id}/${customer_id}/${shipping_id}`;
  return (dispatch) => {
    return axios({
      method: 'put',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        // alert(JSON.stringify(response.data));
        // alert("Quotes set to Orders!");
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        if (err.status === 500 || err.status === 404) {
          // err.data = DEFAULT_ERROR;
        }
        alert("Quote to order failed: " + err.data);
      });
  };
}

export const acknowledgeApi = (ids, success) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/edi/order_acknowledging/${ids}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success()
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(JSON.stringify(err));
  })
}

export const mobileSoDealApi = (id, data, success) => dispatch => {
  // {"to_deal": 1} 0:已处理 1：待处理
  axios({
    method: 'put',
    url: `${ROOT_URL}v1/sale/sales_order/${id}/deal`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data,
  }).then(res => {
    success()
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    if(err.status == 400 && err.data) {
      alert(err.data);
      return
    }
    alert(JSON.stringify(err));
  })
}
export const mobileSoDealQuote = (ids, success = () => {}) => dispatch => {
    axios({
      method: 'post',
      url: `${ROOT_URL}v1/sale/deal_with_quote/${ids}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(success).catch(err => {
      alert(JSON.stringify(err));
    })
}
export const mobileSoSetToDoOrOpen = (data, success, reverseFlag) => dispatch => {
  axios({
    method: 'put',
    url: `${ROOT_URL}v1/sale/shipping/set_to_incomplete?is_reverse=${reverseFlag}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data,
  }).then(res => {
    if (res.status === 200) {
      alert(res.data)
      success()
    }
  }).catch(err => {
    if(err.status == 400 && err.data) {
      alert(err.data);
      return
    }
    alert(JSON.stringify(err));
  })
}


export function setDavisPO(salesOrder_id) {
  const url = `${SO_TO_PO_DAVIS_URL}`;
  let data = {SalesOrder_id: salesOrder_id};
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {
      // alert(JSON.stringify(response.data));
      alert("Sent to Davis PO: " + response.data);
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.status === 500 || err.status === 404) {
        // err.data = DEFAULT_ERROR;
      }
      alert("SO to PO failed: " + err.data);
    });
  };
}

/**
  * Gets previously set product images
  *
  * @param {Number} salesOrder_id
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const fetchBolImage = (salesOrder_id, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'get',
    url: `${MOBILE_SALES_ORDERS_URL}?pk=${salesOrder_id}`,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
};

/**
  * Delete previously saved image
  *
  * @param {Number} imageId
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const deleteBolImage = (imageId, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'delete',
    url: `${OVERSEA_DELETE_BOL_IMAGE_URL}${imageId}`,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
};

/**
  * Updates product images
  *
  * @param {Number} salesOrder_id
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const submitBolImage = (salesOrder_id, images, handleSuccess, handleFailure) => {
  const url = `${OVERSEA_UPLOAD_BOL_IMAGE_URL}${salesOrder_id}`;

  let data = new FormData();
  for (let i = 0; i < images.length; i++) {
    data.append('image', images[i].file[0]);
  }

  const config = {
    method: 'post',
    url: `${OVERSEA_UPLOAD_BOL_IMAGE_URL}${salesOrder_id}`,
    data,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    if (err.status === 500 || err.status === 404) {
      // err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
};

export function fetchBolByIdPDFSuccess(FileData) {
  return {
    type: FETCH_BOL_ID_PDF_SUCCESS,
    payload: FileData,
  };
}

export function printBolById(salesOrder_id) {
  if (salesOrder_id) {
    return (dispatch) => {
      dispatch({ type: REQUEST_BOL_ID_PDF });
      return axios.get(
        OVERSEA_PRINT_BOL_URL + salesOrder_id,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchBolByIdPDFSuccess(response));
        }, (err) => {
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
            return
          }
          console.log('Print Bol failed', err);
        });
    };
  }
}

export function fetchPrintBolWithoutLogSuccess(FileData) {
  return {
    type: FETCH_BOL_WITHOUT_LOG_SUCCESS,
    payload: FileData,
  };
}

export function printBolWithoutLog(salesOrder_id) {
  if (salesOrder_id) {
    return (dispatch) => {
      dispatch({ type: REQUEST_BOL_WITHOUT_LOG });
      return axios.get(
        OVERSEA_PRINT_BOL_WITHOUT_LOG_URL + salesOrder_id,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchBolByIdPDFSuccess(response));
        }, (err) => {
          console.log('Print Bol failed', err);
        });
    };
  }
}

export function fetchPrintBolLabelSuccess(FileData) {
  return {
    type: FETCH_BOL_LABEL_SUCCESS,
    payload: FileData,
  };
}

export function printBolLabel(salesOrder_id) {
  if (salesOrder_id) {
    return (dispatch) => {
      dispatch({ type: REQUEST_BOL_LABEL });
      return axios.get(
        OVERSEA_PRINT_BOL_LABEL_URL + salesOrder_id,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchPrintBolLabelSuccess(response));
        }, (err) => {
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
            return
          }
          console.log('Print Bol label failed', err);
        });
    };
  }
}

export function fetchBolByFbaPDFSuccess(FileData) {
  return {
    type: FETCH_BOL_FBA_PDF_SUCCESS,
    payload: FileData,
  };
}

export function printBolByFba(fba_code) {
  if (fba_code) {
    return (dispatch) => {
      dispatch({ type: REQUEST_BOL_FBA_PDF });
      return axios.get(
        `${OVERSEA_PRINT_BOL_URL}?FBACode=${fba_code}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchBolByFbaPDFSuccess(response));
        }, (err) => {
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
            return
          }
          if (err.status === 400) {
            alert('cannot find sales order');
          }
          console.log('Print Bol failed', err);
        });
    };
  }
}

export function fetchSPSuccess(FileData) {
  return {
    type: FETCH_SP_SUCCESS,
    payload: FileData,
  };
}

export function printSP(days, fromDate, toDate) {
  const dates = toFromDates(days, fromDate, toDate);

  let psfromDate = `date__gte=${dates.fromDate}`;
  let pstoDate = `date__lte=${dates.toDate}`;

  let belongWarehouse = ``;
  if ( isAFM ){
    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
      belongWarehouse = ``;
    } else {
      belongWarehouse = `&BelongWarehouse=${localStorage.getItem('warehouseLocation')}`;
    }
  }

    return (dispatch) => {
      dispatch({ type: REQUEST_SP_PDF });
      return axios.get(
        `${SP_PDF_URL}?${psfromDate}&${pstoDate}${belongWarehouse}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchSPSuccess(response));
        }, (err) => {
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
            return
          }
          if (err.status === 400) {
            alert('fetch failed');
          }
        });
    };
}

export function fetchBolAddressSuccess(address) {
  return {
    type: FETCH_BOL_ADDRESS_SUCCESS,
    payload: address,
  };
}

export function fetchBolAddress() {
  return (dispatch) => {
    return axios.get(
      OVERSEA_ADDRESS_URL,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then((response) => {
        dispatch(fetchBolAddressSuccess(response));
      }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        console.log('fetch Bol Address failed:', err);
      });
  };
}

export function chowbusImport(file) {
  const url = `${CHOWBUS_IMPORT}`;
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: file,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function getPaymentTerms() {
  const url = `${PAYMENT_URL}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchFJAgents(customer) {
  const url = `${FETCH_FJ_AGENTS_URL}${customer}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchFJCarriers() {
  const url = `${FETCH_FJ_CARRIERS_URL}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchFBAAddressOptions() {
  const url = `${FETCH_FBA_ADDRESS_URL}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchCompany() {
  const url = `${COMPANY_URL}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchWarehousesByCompany(id) {
  const url = `${WAREHOUSE_BY_COMPANY_URL}${id}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function selectTeapplixShipping(method, salesOrderId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    let params = {};
    if (method) {
      params.shipping_method = method;
    }
    return axios.post(
      `${ROOT_URL}v2/shipping/teapplix_label/${salesOrderId}`,
      params,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(printTeapplixLabel(salesOrderId));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        dispatch(fetchSalesOrderPDFSuccess([]));
        alert('Failed on select teapplix label: ' + err.data);
      });
  };
}

// for sunset
export function selectTeapplixShipping2(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.post(
      `${ROOT_URL}v2/shipping/teapplix_ecom_label/${id}`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
    .then((response) => {
      dispatch(fetchSalesOrderPDFSuccess(response));
    }, (err) => {
      console.log('err: ', err);
      dispatch(fetchSalesOrderPDFSuccess([]));
      alert('Failed on print teapplix label: ' + err.data.detail);
    });
  };
}

export function printTeapplixLabel(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      `${ROOT_URL}v2/shipping/teapplix_label/${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        dispatch(fetchSalesOrderPDFSuccess([]));
        alert('Failed on print teapplix label: '+ err.data);
      });
  };
}

export function deleteTeapplixShipping(id, success) {
  return (dispatch) => {
    // dispatch({ type: REQUEST_SO_PDF });
    return axios.delete(
      `${ROOT_URL}v2/shipping/teapplix_label/${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        success();
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
          return
        }
        dispatch(fetchSalesOrderPDFSuccess([]));
        alert('Failed on delete teapplix label: '+ err.data);
      });
  };
}

export const uploadSOFile = (pk, file, success) => dispatch => {
  axios({
    method: 'post',
    url: `${ROOT_URL}v1/sale/sales_order/upload_file/${pk}`,
    data: file,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success()
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}


export const teapplixResyncWithPONum = (PONum, success, failed) => dispatch => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v2/sales/teapplix_resync?PONum=${PONum}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success(res.data)
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}

export const rollBackWithSOIds = (SOIds, success, failed) => dispatch => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/sales_order/restock_cancel/${SOIds}/`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success(res.data)
  }).catch(err => {
    alert(err.data);
  })
}
export const stuffResyncWithPONum = (PONum, type, success, failed) => dispatch => {
  // POST /v2/sales/external_order_resync {'platform': <'shipstation' or 'nuorder'>, 'ponum': '123'}
  let data = {
    platform: type,
    ponum: PONum, 
  };
  axios({
    method: 'POST',
    url: `${ROOT_URL}v2/sales/external_order_resync`,
    data: data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success(res.data)
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}

export const abcffSync = (SOIds, success, failed) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/sale/outbound_from_mso/${SOIds}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success();
  }).catch(err => {
    alert(err.data);
  })
}

export const convertProduct = (product_id, quantity, warehouse, success) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v2/inventory/working-order/big2small_convert`,
    params: {
      product_id,
      quantity,
      warehouse,
    },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success()
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
      return
    }
    alert(err.data);
  })
}
export const setQuoteReview = (id, reviewUserId, status, callback = () => {}) => {
  const token = localStorage.getItem('token');
  const data = { Req_Review_Status: status }
  if (reviewUserId) {
    data.Req_Review_User_id = reviewUserId;
  }
  axios.put(
    `${MFG_SALES_ORDER_REVIEW_URL}${id}/`,
    data,
    {
      params: {Module: 'so'},
      headers: {Authorization: `Bearer ${token}`}
    }
  ).then(response => {
    if (response.status !== 200) {
      alert(response.data)
      return;
    }
    callback(response.data);
  })
}
export const setQuoteApproval = (id, status, callback = () => {}) => {
  const token = localStorage.getItem('token');
  axios.put(
    `${MFG_SALES_ORDER_REQ_APPROVAL_URL}${id}/`,
    {
      Req_Approve_Status: status,
    },
    {
      headers: {Authorization: `Bearer ${token}`}
    }
  ).then(response => {
    if (response.status !== 200) {
      alert(response.data)
    }
    callback(response.data);
  })
}
export const setOrderReview = (id, reviewUserId, status, callback = () => {}) => {
  const token = localStorage.getItem('token');
  const data = { Review_Status: status }
  if (reviewUserId) {
    data.Review_User_id = reviewUserId;
  }
  axios.put(
    `${MFG_SALES_ORDER_REVIEW_URL}${id}/`,
    data,
    {
      params: {Module: 'so'},
      headers: {Authorization: `Bearer ${token}`}
    }
  ).then(response => {
    if (response.status !== 200) {
      alert(response.data)
      return;
    }
    callback(response.data);
  })
}

export const setOrderApproval = (id, status, callback = () => {}) => {
  const token = localStorage.getItem('token');
  axios.put(
    `${MFG_SALES_ORDER_PENDING_APPROVAL_URL}${id}/`,
    {
      Approve_Status: status,
    },
    {
      headers: {Authorization: `Bearer ${token}`}
    }
  ).then(response => {
    if (response.status !== 200) {
      alert(response.data)
    }
    callback();
  })
}

export const fetchRollingGate = (data, success) => dispatch => {
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v1/sale/sales_order/rolling_gate`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success(res.data)
  }).catch(err => {
    alert(err.data);
    // if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
    //   document.getElementById('tokenInvalid').style.display = 'flex'
    //   return
    // }
    // alert(err.data);
  })
}
export const fetchOrderRequests = (activeIdx, salesOrderLine) => ({
  type: FETCH_CURRENT_ORDER_REQUESTS,
  activeIdx,
  salesOrderLine,
})
export const addProductRequests = (value) => ({
  type: ADD_PRODUCT_REQUESTS,
  value,
})

export const addProductImages = (name, url) => ({
  type: ADD_PRODUCT_IMAGES,
  name,
  url,
})
export const removeProductImages = index => ({
  type: REMOVE_PRODUCT_IMAGES,
  index,
})
export const addProductFiles = (name, url) => ({
  type: ADD_PRODUCT_FILES,
  name,
  url,
})
export const removeProductFiles = index => ({
  type: REMOVE_PRODUCT_FILES,
  index,
})



// WEBPACK FOOTER //
// ./master/jsx/actions/sales_actions.js